/* Auto-generated by scripts/build-cost-bom-assets.mjs */
export const MI_NODES = {
  c0: {
    name: 'Citric Acid',
    cost: 2.2132362878918332,
    mass: 1,
    profile: 'assembly',
    sources: [{ n: 'Germany', p: 1 }],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.109017873489248,
      Labor: 0.2357393303158243,
      Overhead: 0.6478744976393553,
      'Value Add': 0.22060458644740566,
    },
  },
  c1: {
    name: 'Activated carbon',
    cost: 0.004195062205134777,
    mass: 0.005,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.37788489501504174 },
      { n: 'Rest of World', p: 0.35168517828967566 },
      { n: 'China', p: 0.16085841968436929 },
      { n: 'Philippines', p: 0.10957150701091342 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0027490413554232887,
      Labor: 0.00036277905522530786,
      Overhead: 0.0005342475447863182,
      'Value Add': 0.0005489942496998619,
    },
  },
  c2: {
    name: 'Ammonium sulfate',
    cost: 0.006205984047061681,
    mass: 0.034,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.4339108683351428 },
      { n: 'Belgium', p: 0.2291098077887853 },
      { n: 'Rest of World', p: 0.22414277667295424 },
      { n: 'China', p: 0.11283654720311763 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0026197371139753643,
      Labor: 0.0007326126037903675,
      Overhead: 0.0012488343166825598,
      'Value Add': 0.00160480001261339,
    },
  },
  c3: {
    name: 'Calcium hydroxide (Ca(OH)2)',
    cost: 0.14798955706773398,
    mass: 0.58,
    profile: 'assembly',
    sources: [{ n: 'Germany', p: 1 }],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 0.07931384, Overhead: 0.068675717067734 },
  },
  c65: {
    name: 'Calcium oxide (quicklime)',
    cost: 0.0665028,
    mass: 0.45239999999999997,
    profile: 'material',
    sources: [{ n: 'Germany', p: 1 }],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.03208097332533132,
      Labor: 0.013580473954402941,
      Overhead: 0.011005016749407532,
      'Value Add': 0.0098363359708582,
    },
  },
  c66: {
    name: 'Process water',
    cost: 0.012811039999999996,
    mass: 0.14558,
    profile: 'material',
    sources: [{ n: 'Germany', p: 1 }],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.007213757995525622,
      Labor: 0.0027285250053167647,
      Overhead: 0.0009014828631577692,
      'Value Add': 0.00196727413599984,
    },
  },
  c4: {
    name: 'Copper(II) sulfate pentahydrate',
    cost: 7.199779847637864e-5,
    mass: 2e-5,
    profile: 'assembly',
    sources: [
      { n: 'Rest of World', p: 0.3608998846059375 },
      { n: 'Germany', p: 0.24506766288207354 },
      { n: 'Poland', p: 0.23773204033319745 },
      { n: 'Italy', p: 0.15630041217879156 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 7.199779847637864e-5 },
  },
  c77: {
    name: 'Copper(II) oxide',
    cost: 6.778136539945212e-5,
    mass: 6.640000000000001e-6,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5133852495301363 },
      { n: 'Germany', p: 0.3082452340444808 },
      { n: 'United States', p: 0.0653186799602388 },
      { n: 'Czechia', p: 0.02573452593637779 },
      { n: 'Italy', p: 0.03627781543210639 },
      { n: 'India', p: 0.02694588902740231 },
      { n: 'Peru', p: 0.02409260606925776 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.5277793273837373e-5,
      Labor: 1.003776658727767e-5,
      Overhead: 1.1649293725151243e-5,
      'Value Add': 1.0816511813185837e-5,
    },
  },
  c78: {
    name: 'Sulfuric acid (96%)',
    cost: 4.19544695280891e-6,
    mass: 8.52e-6,
    profile: 'assembly',
    sources: [
      { n: 'Rest of World', p: 0.3608998846059375 },
      { n: 'Germany', p: 0.24506766288207354 },
      { n: 'Poland', p: 0.23773204033319745 },
      { n: 'Italy', p: 0.15630041217879156 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 4.19544695280891e-6 },
  },
  c88: {
    name: 'Deionized water',
    cost: 1.962172970369942e-6,
    mass: 3.445588235294118e-6,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.3608998846059375 },
      { n: 'Germany', p: 0.24506766288207354 },
      { n: 'Poland', p: 0.23773204033319745 },
      { n: 'Italy', p: 0.15630041217879156 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.2017845377373053e-6,
      Labor: 2.857534901071019e-7,
      Overhead: 1.468945831176423e-7,
      'Value Add': 3.277403594078924e-7,
    },
  },
  c89: {
    name: 'Elemental sulfur',
    cost: 2.233273982438968e-6,
    mass: 5.0744117647058825e-6,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5326833817682477 },
      { n: 'Germany', p: 0.1101178168692655 },
      { n: 'Russia', p: 0.12896756158828293 },
      { n: 'China', p: 0.041385810494818556 },
      { n: 'Poland', p: 0.08713267943932834 },
      { n: 'Italy', p: 0.09971274984005705 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.2021250824039668e-6,
      Labor: 2.7207011520379234e-7,
      Overhead: 3.9049563526123285e-7,
      'Value Add': 3.6858314956997633e-7,
    },
  },
  c79: {
    name: 'Water',
    cost: 2.098612411761359e-8,
    mass: 5.68e-6,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.3608998846059375 },
      { n: 'Germany', p: 0.24506766288207354 },
      { n: 'Poland', p: 0.23773204033319745 },
      { n: 'Italy', p: 0.15630041217879156 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.1321708430478064e-8,
      Labor: 2.659959105878591e-9,
      Overhead: 1.098031340082471e-9,
      'Value Add': 5.906425241174461e-9,
    },
  },
  c5: {
    name: 'Dipotassium phosphate (K2HPO4)',
    cost: 0.0025582017257680953,
    mass: 0.0021,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.7056258079495279 },
      { n: 'Rest of World', p: 0.1614779449621735 },
      { n: 'Belgium', p: 0.07149185365706741 },
      { n: 'United States', p: 0.06140439343123113 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 0.0025582017257680953 },
  },
  c75: {
    name: 'Phosphoric acid (85% solution)',
    cost: 0.0017779447265771375,
    mass: 0.0014322,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.4876875559510228 },
      { n: 'China', p: 0.15181109495303272 },
      { n: 'Belgium', p: 0.19528724096939004 },
      { n: 'Germany', p: 0.10468578757731478 },
      { n: 'Morocco', p: 0.026616279419636558 },
      { n: 'United States', p: 0.03391204112960308 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.000938890892476427,
      Labor: 0.00024334331198639294,
      Overhead: 0.00030783751512282367,
      'Value Add': 0.00028787300699149404,
    },
  },
  c76: {
    name: 'Potassium hydroxide (90% purity)',
    cost: 0.0007802569991909578,
    mass: 0.0015497999999999998,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.19861658430266038 },
      { n: 'Rest of World', p: 0.3555886250210811 },
      { n: 'Belgium', p: 0.2285211624304624 },
      { n: 'Czechia', p: 0.1589574575974137 },
      { n: 'United States', p: 0.058316170648382445 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 0.0007802569991909578 },
  },
  c80: {
    name: 'Potassium chloride',
    cost: 0.000778492270939625,
    mass: 0.0019930428,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.3550270789820761 },
      { n: 'Rest of World', p: 0.44258655743689207 },
      { n: 'Canada', p: 0.16702348642358483 },
      { n: 'Belgium', p: 0.035362877157446945 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0003959886462825129,
      Labor: 0.00012883461565832413,
      Overhead: 0.00013225506915412143,
      'Value Add': 0.00012141393984466649,
    },
  },
  c81: {
    name: 'Water',
    cost: 1.7647282513328224e-6,
    mass: 0.00048198779999999997,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.19861658430266038 },
      { n: 'Rest of World', p: 0.3555886250210811 },
      { n: 'Belgium', p: 0.2285211624304624 },
      { n: 'Czechia', p: 0.1589574575974137 },
      { n: 'United States', p: 0.058316170648382445 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 9.294544154377983e-7,
      Labor: 2.597446740541403e-7,
      Overhead: 9.064182760390259e-8,
      'Value Add': 4.848873342369813e-7,
    },
  },
  c6: {
    name: 'Iron(II) sulfate heptahydrate',
    cost: 3.267887910520085e-5,
    mass: 0.0001,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.553975077418917 },
      { n: 'Rest of World', p: 0.26559022097017737 },
      { n: 'Netherlands', p: 0.11295865011497806 },
      { n: 'France', p: 0.06747605149592746 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 3.267887910520085e-5 },
  },
  c23: {
    name: 'Iron (metallic iron)',
    cost: 1.5050971191987694e-5,
    mass: 3.582342954159592e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.2525483998602537 },
      { n: 'Rest of World', p: 0.5584852586889011 },
      { n: 'Ukraine', p: 0.05166688614772501 },
      { n: 'Sweden', p: 0.03660104229420337 },
      { n: 'Brazil', p: 0.06328301343858286 },
      { n: 'Netherlands', p: 0.037415399570334004 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 1.5050971191987694e-5 },
  },
  c35: {
    name: 'Iron ore (hematite, 62% Fe content)',
    cost: 9.0734605322643e-6,
    mass: 8.884210526315789e-5,
    profile: 'material',
    sources: [
      { n: 'Canada', p: 0.1078076344850305 },
      { n: 'Rest of World', p: 0.6353338947867614 },
      { n: 'South Africa', p: 0.04899773467308713 },
      { n: 'Sweden', p: 0.0750749102881176 },
      { n: 'Ukraine', p: 0.05166648823139678 },
      { n: 'Brazil', p: 0.08111933753560671 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 5.7501124137673765e-6,
      Labor: 5.38609194288004e-7,
      Overhead: 6.901584935003844e-7,
      'Value Add': 2.094580430708536e-6,
    },
  },
  c36: {
    name: 'Limestone (carbonate flux)',
    cost: 2.182242993227153e-7,
    mass: 8.95585738539898e-6,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.2525483998602537 },
      { n: 'Rest of World', p: 0.5584852586889011 },
      { n: 'Ukraine', p: 0.05166688614772501 },
      { n: 'Sweden', p: 0.03660104229420337 },
      { n: 'Brazil', p: 0.06328301343858286 },
      { n: 'Netherlands', p: 0.037415399570334004 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.0828412559111662e-7,
      Labor: 4.243866500840343e-8,
      Overhead: 2.2067653466844427e-8,
      'Value Add': 4.543385525635085e-8,
    },
  },
  c37: {
    name: 'Metallurgical coke (from coal)',
    cost: 5.7592863604006785e-6,
    mass: 1.683701188455008e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.2525483998602537 },
      { n: 'Rest of World', p: 0.5584852586889011 },
      { n: 'Ukraine', p: 0.05166688614772501 },
      { n: 'Sweden', p: 0.03660104229420337 },
      { n: 'Brazil', p: 0.06328301343858286 },
      { n: 'Netherlands', p: 0.037415399570334004 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.689017089756014e-6,
      Labor: 4.362634502613914e-7,
      Overhead: 6.281457894958831e-7,
      'Value Add': 1.00586003088739e-6,
    },
  },
  c24: {
    name: 'Sulfuric acid (98%)',
    cost: 1.7627907913213153e-5,
    mass: 6.417657045840407e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.553975077418917 },
      { n: 'Rest of World', p: 0.26559022097017737 },
      { n: 'Netherlands', p: 0.11295865011497806 },
      { n: 'France', p: 0.06747605149592746 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 1.7627907913213153e-5 },
  },
  c38: {
    name: 'Elemental sulfur',
    cost: 1.7534671078835742e-5,
    mass: 3.982113574933232e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.25077543676572384 },
      { n: 'Rest of World', p: 0.514470116581532 },
      { n: 'Russia', p: 0.07686362476941631 },
      { n: 'China', p: 0.042651878501989975 },
      { n: 'Netherlands', p: 0.0815081105604051 },
      { n: 'France', p: 0.0337308328209327 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 9.169274250392701e-6,
      Labor: 2.5331714467577245e-6,
      Overhead: 3.020837422187671e-6,
      'Value Add': 2.8113879594976453e-6,
    },
  },
  c39: {
    name: 'Water',
    cost: 9.323683437741142e-8,
    mass: 2.435543470907175e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.553975077418917 },
      { n: 'Rest of World', p: 0.26559022097017737 },
      { n: 'Netherlands', p: 0.11295865011497806 },
      { n: 'France', p: 0.06747605149592746 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 4.8003044654742714e-8,
      Labor: 1.5484770572191596e-8,
      Overhead: 4.706297343691875e-9,
      'Value Add': 2.504272180678523e-8,
    },
  },
  c7: {
    name: 'Magnesium sulfate heptahydrate (MgSO4·7H2O)',
    cost: 0.0007487352597409042,
    mass: 0.0017,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.9883266441588218 },
      { n: 'Rest of World', p: 0.011673355841178235 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.00022522051028628492,
      Labor: 9.477342869637661e-5,
      Overhead: 0.0003596865391517639,
      'Value Add': 6.905478160647871e-5,
    },
  },
  c14: {
    name: 'Magnesium oxide',
    cost: 9.650648316023181e-5,
    mass: 0.00028900000000000003,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.3801039411383787 },
      { n: 'China', p: 0.2929432475077198 },
      { n: 'Germany', p: 0.21181691422445784 },
      { n: 'Netherlands', p: 0.11513589712944372 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 5.1344694511609317e-5,
      Labor: 1.2645605496399657e-5,
      Overhead: 1.6773404390006077e-5,
      'Value Add': 1.5742778762216758e-5,
    },
  },
  c15: {
    name: 'Sulfuric acid',
    cost: 0.00012492321524487188,
    mass: 0.0007055,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.6648785474110017 },
      { n: 'Rest of World', p: 0.14647659497718532 },
      { n: 'Poland', p: 0.0993223192581854 },
      { n: 'Belgium', p: 0.08932253835362756 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 6.220887377041205e-5,
      Labor: 2.2641614802412514e-5,
      Overhead: 2.0998885720615982e-5,
      'Value Add': 1.9073840951431343e-5,
    },
  },
  c16: {
    name: 'Water',
    cost: 3.7908118811812307e-6,
    mass: 0.0009061,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.9883266441588218 },
      { n: 'Rest of World', p: 0.011673355841178235 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.9031741162085956e-6,
      Labor: 7.070566610811799e-7,
      Overhead: 1.8771366631784045e-7,
      'Value Add': 9.928674375736147e-7,
    },
  },
  c8: {
    name: 'Manganese(II) sulfate monohydrate',
    cost: 8.620200637736978e-5,
    mass: 3e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.553975077418917 },
      { n: 'Rest of World', p: 0.26559022097017737 },
      { n: 'Netherlands', p: 0.11295865011497806 },
      { n: 'France', p: 0.06747605149592746 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 8.620200637736978e-5 },
  },
  c33: {
    name: 'Manganese carbonate',
    cost: 8.099172551136465e-5,
    mass: 2.148e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.5747545249467256 },
      { n: 'Rest of World', p: 0.3694933665898184 },
      { n: 'Poland', p: 0.03543892740321026 },
      { n: 'Netherlands', p: 0.02031318106024561 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 8.099172551136465e-5 },
  },
  c72: {
    name: 'Manganese sulfate monohydrate',
    cost: 6.672154144671406e-5,
    mass: 3.4325040000000004e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.3220835112122104 },
      { n: 'Rest of World', p: 0.5371489978704066 },
      { n: 'Netherlands', p: 0.07526063350451348 },
      { n: 'France', p: 0.03878216592282258 },
      { n: 'Poland', p: 0.02672469149004658 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 6.672154144671406e-5 },
  },
  c84: {
    name: 'Pyrolusite ore (85% MnO₂)',
    cost: 6.309625496117056e-5,
    mass: 2.1865050480000003e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.3220835112122104 },
      { n: 'Rest of World', p: 0.5371489978704068 },
      { n: 'Netherlands', p: 0.07526063350451348 },
      { n: 'France', p: 0.03878216592282258 },
      { n: 'Poland', p: 0.02672469149004658 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.25642223201909e-5,
      Labor: 9.749587236997938e-6,
      Overhead: 1.0797940628430018e-5,
      'Value Add': 9.984504775551701e-6,
    },
  },
  c85: {
    name: 'Sulfuric acid (98%)',
    cost: 3.6252864855434867e-6,
    mass: 2.141882496e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.3220835112122104 },
      { n: 'Rest of World', p: 0.5371489978704068 },
      { n: 'Netherlands', p: 0.07526063350451348 },
      { n: 'France', p: 0.03878216592282258 },
      { n: 'Poland', p: 0.02672469149004658 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.8710244397591029e-6,
      Labor: 5.601766201760663e-7,
      Overhead: 6.204112788633576e-7,
      'Value Add': 5.736741467449601e-7,
    },
  },
  c73: {
    name: 'Process water',
    cost: 6.830781988679862e-6,
    mass: 8.592e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.5747545249467256 },
      { n: 'Rest of World', p: 0.36949336658981835 },
      { n: 'Poland', p: 0.03543892740321026 },
      { n: 'Netherlands', p: 0.02031318106024561 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 4.032480861747173e-6,
      Labor: 1.2009875717896244e-6,
      Overhead: 4.976100014405357e-7,
      'Value Add': 1.0997035537025292e-6,
    },
  },
  c74: {
    name: 'Sodium carbonate',
    cost: 7.4394020759707255e-6,
    mass: 2.304804e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.2508477630292695 },
      { n: 'Belgium', p: 0.12984583356433557 },
      { n: 'Rest of World', p: 0.5130701235152297 },
      { n: 'France', p: 0.08283671253705073 },
      { n: 'Poland', p: 0.023399567354114338 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.821610196307893e-6,
      Labor: 1.1759126181751195e-6,
      Overhead: 1.2701367005829283e-6,
      'Value Add': 1.1717425609047842e-6,
    },
  },
  c34: {
    name: 'Sulfuric acid (96% solution)',
    cost: 5.2102808660051345e-6,
    mass: 1.9050000000000002e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.4254369160307581 },
      { n: 'Rest of World', p: 0.37951621636298144 },
      { n: 'Poland', p: 0.055671968195605714 },
      { n: 'Belgium', p: 0.08734166512346814 },
      { n: 'Netherlands', p: 0.05203323428718659 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 5.2102808660051345e-6 },
  },
  c86: {
    name: 'Elemental sulfur',
    cost: 5.18360594138315e-6,
    mass: 1.1779007633587788e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.18755398359068828 },
      { n: 'Rest of World', p: 0.6099058822278969 },
      { n: 'Russia', p: 0.0812678152319146 },
      { n: 'China', p: 0.038028542379464826 },
      { n: 'Belgium', p: 0.04569790815908581 },
      { n: 'Netherlands', p: 0.03754586841094963 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 2.7417235561480163e-6,
      Labor: 7.030067596454737e-7,
      Overhead: 8.982367283840856e-7,
      'Value Add': 8.40638897205575e-7,
    },
  },
  c87: {
    name: 'Water',
    cost: 2.667492462198446e-8,
    mass: 7.270992366412215e-6,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.4254369160307581 },
      { n: 'Rest of World', p: 0.37951621636298144 },
      { n: 'Poland', p: 0.055671968195605714 },
      { n: 'Belgium', p: 0.08734166512346814 },
      { n: 'Netherlands', p: 0.05203323428718659 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.3989911006548932e-8,
      Labor: 4.020952352231475e-9,
      Overhead: 1.3656606730224597e-9,
      'Value Add': 7.298400590181593e-9,
    },
  },
  c9: {
    name: 'Monopotassium phosphate (KH2PO4)',
    cost: 0.0031512628613162177,
    mass: 0.0021,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.7056258079495279 },
      { n: 'Rest of World', p: 0.1614779449621735 },
      { n: 'Belgium', p: 0.07149185365706741 },
      { n: 'United States', p: 0.06140439343123113 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 0.0031512628613162177 },
  },
  c25: {
    name: 'Phosphoric acid (85% concentration)',
    cost: 0.0022419830862996154,
    mass: 0.0018059999999999999,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.4876875559510228 },
      { n: 'China', p: 0.15181109495303272 },
      { n: 'Belgium', p: 0.19528724096939004 },
      { n: 'Germany', p: 0.10468578757731478 },
      { n: 'Morocco', p: 0.026616279419636558 },
      { n: 'United States', p: 0.03391204112960308 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0011839386620670484,
      Labor: 0.0003068552027980907,
      Overhead: 0.0003881822038205693,
      'Value Add': 0.0003630070176139073,
    },
  },
  c26: {
    name: 'Potassium hydroxide (85% purity)',
    cost: 0.0009092797750166024,
    mass: 0.0010332,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.19861658430266038 },
      { n: 'Rest of World', p: 0.3555886250210811 },
      { n: 'Belgium', p: 0.2285211624304624 },
      { n: 'Czechia', p: 0.1589574575974137 },
      { n: 'United States', p: 0.058316170648382445 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.00046479160659421544,
      Labor: 0.00014712273583300598,
      Overhead: 0.00015485584123338235,
      'Value Add': 0.0001425095913559985,
    },
  },
  c10: {
    name: 'Process water',
    cost: 0.07169306787027042,
    mass: 7.7,
    profile: 'material',
    sources: [{ n: 'Germany', p: 1 }],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.04103326552757277,
      Labor: 0.01552038356585136,
      Overhead: 0.003949178954817735,
      'Value Add': 0.011190239822028561,
    },
  },
  c11: {
    name: 'Sucrose-equivalent fermentable sugar (from refined sucrose or molasses)',
    cost: 0.6465614182905232,
    mass: 1.19,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.7746174905310828 },
      { n: 'Rest of World', p: 0.15815244584971322 },
      { n: 'France', p: 0.06723006361920404 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.5867744755707053,
      Labor: 0.014187651297813802,
      Overhead: 0.0356418912307557,
      'Value Add': 0.009957400191248328,
    },
  },
  c17: {
    name: 'Fructose',
    cost: 0.028198308477642344,
    mass: 0.011959798994974876,
    profile: 'assembly',
    sources: [
      { n: 'Turkey', p: 0.4661057937402455 },
      { n: 'Finland', p: 0.12130967630904053 },
      { n: 'Israel', p: 0.08915381031058667 },
      { n: 'Rest of World', p: 0.25715595557244425 },
      { n: 'Germany', p: 0.04082638799388083 },
      { n: 'Bulgaria', p: 0.02544837607380219 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.026639855562719868,
      Labor: 0.00021341444009579402,
      Overhead: 0.0007405324500095382,
      'Value Add': 0.0006045060248171451,
    },
  },
  c27: {
    name: 'D-Glucose (from enzymatic corn starch hydrolysate)',
    cost: 0.02660047919734077,
    mass: 0.03587939698492463,
    profile: 'material',
    sources: [
      { n: 'Turkey', p: 0.423728048524673 },
      { n: 'Rest of World', p: 0.3857322161288911 },
      { n: 'Lithuania', p: 0.0468004849455262 },
      { n: 'Germany', p: 0.05052277881454339 },
      { n: 'France', p: 0.02261102936288723 },
      { n: 'China', p: 0.04684203057203389 },
      { n: 'Bulgaria', p: 0.02376341165144522 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.019311830611295815,
      Labor: 0.0010067589362108785,
      Overhead: 0.0027309656515852477,
      'Value Add': 0.003550923998248828,
    },
  },
  c28: {
    name: 'Glucose isomerase (immobilized, industrial grade)',
    cost: 1.4924129294718002e-6,
    mass: 1.1959798994974876e-7,
    profile: 'assembly',
    sources: [
      { n: 'Turkey', p: 0.17068058177448647 },
      { n: 'Denmark', p: 0.1655575871881137 },
      { n: 'Rest of World', p: 0.4288420514012936 },
      { n: 'Finland', p: 0.15795926459416876 },
      { n: 'Israel', p: 0.05420002893332705 },
      { n: 'Bulgaria', p: 0.022760486108610332 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.3768088379194761e-6,
      Labor: 2.2735663857368994e-8,
      Overhead: 5.893698208655072e-8,
      'Value Add': 3.393144560840431e-8,
    },
  },
  c45: {
    name: 'Ammonium sulfate (technical grade)',
    cost: 2.3464898057307314e-9,
    mass: 7.4150753768844235e-9,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.1500903858836081 },
      { n: 'Rest of World', p: 0.5291644811263276 },
      { n: 'Netherlands', p: 0.144375825435794 },
      { n: 'Finland', p: 0.15507360668076411 },
      { n: 'Switzerland', p: 0.02129570087350608 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.0469849266475886e-9,
      Labor: 2.222773966250021e-10,
      Overhead: 4.358648760627115e-10,
      'Value Add': 6.413626063954293e-10,
    },
  },
  c46: {
    name: 'Cross-linked agarose (immobilization carrier, technical grade)',
    cost: 4.1185068379659887e-7,
    mass: 1.0763819095477389e-7,
    profile: 'material',
    sources: [
      { n: 'Turkey', p: 0.18358606818289 },
      { n: 'Rest of World', p: 0.5361618872872934 },
      { n: 'France', p: 0.05190798073732672 },
      { n: 'Finland', p: 0.1949450854455071 },
      { n: 'Bosnia and Herzegovina', p: 0.033398978346982786 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 2.7920465490706546e-7,
      Labor: 3.3054593490219795e-8,
      Overhead: 4.3833179987469726e-8,
      'Value Add': 5.5758255411843904e-8,
    },
  },
  c47: {
    name: 'Ethanol (99.5% purity)',
    cost: 5.519571510088703e-9,
    mass: 5.979899497487439e-9,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5828801456943732 },
      { n: 'Brazil', p: 0.05208309773804915 },
      { n: 'Russia', p: 0.033119929230387354 },
      { n: 'Turkey', p: 0.022206303156168887 },
      { n: 'Netherlands', p: 0.071610479158197 },
      { n: 'Belgium', p: 0.03398291981513066 },
      { n: 'Germany', p: 0.030939190452138415 },
      { n: 'Finland', p: 0.08911726057744315 },
      { n: 'United Kingdom', p: 0.03835548056978002 },
      { n: 'United States', p: 0.024366279229329265 },
      { n: 'Bulgaria', p: 0.021338914379002864 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 4.330232491946489e-9,
      Labor: 1.038208528046661e-10,
      Overhead: 4.535936152810299e-10,
      'Value Add': 6.319245500565181e-10,
    },
  },
  c48: {
    name: 'Glucose (technical grade)',
    cost: 9.482926512851558e-7,
    mass: 1.3275376884422113e-6,
    profile: 'material',
    sources: [
      { n: 'Turkey', p: 0.15955456263744636 },
      { n: 'Rest of World', p: 0.5457414013170668 },
      { n: 'Belgium', p: 0.042505589900250815 },
      { n: 'France', p: 0.05624679378728063 },
      { n: 'Germany', p: 0.08528143329927383 },
      { n: 'Lithuania', p: 0.06093965798583916 },
      { n: 'China', p: 0.028477071293480653 },
      { n: 'Bulgaria', p: 0.021253489779361708 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 6.788659204068321e-7,
      Labor: 4.7818014865937084e-8,
      Overhead: 9.678361077581221e-8,
      'Value Add': 1.248251052365744e-7,
    },
  },
  c49: {
    name: 'Glutaraldehyde (technical grade)',
    cost: 1.5509455812523288e-9,
    mass: 1.0763819095477388e-9,
    profile: 'material',
    sources: [
      { n: 'Turkey', p: 0.17068058177448647 },
      { n: 'Denmark', p: 0.1655575871881137 },
      { n: 'Rest of World', p: 0.42884205140129367 },
      { n: 'Finland', p: 0.15795926459416876 },
      { n: 'Israel', p: 0.05420002893332705 },
      { n: 'Bulgaria', p: 0.022760486108610332 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.040159614355884e-9,
      Labor: 1.391847927309053e-10,
      Overhead: 1.6387725399792904e-10,
      'Value Add': 2.0772392016761028e-10,
    },
  },
  c50: {
    name: 'Magnesium sulfate heptahydrate (technical grade)',
    cost: 7.142549582221323e-11,
    mass: 2.3919597989949755e-10,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.11612186938038527 },
      { n: 'Turkey', p: 0.05272263780146946 },
      { n: 'Rest of World', p: 0.5307666281020862 },
      { n: 'Germany', p: 0.30038886471605913 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.783065376514373e-11,
      Labor: 9.609949329555043e-12,
      Overhead: 1.2385649255143211e-11,
      'Value Add': 1.1599243472371247e-11,
    },
  },
  c51: {
    name: 'Polyethylene glycol 2000 (antifoam agent)',
    cost: 8.371921663664427e-10,
    mass: 1.1959798994974876e-9,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.06765981315418061 },
      { n: 'Rest of World', p: 0.6168079156703622 },
      { n: 'South Korea', p: 0.04452241158653167 },
      { n: 'Netherlands', p: 0.1194307327523265 },
      { n: 'Germany', p: 0.07945222298351948 },
      { n: 'Denmark', p: 0.020070747471719906 },
      { n: 'Sweden', p: 0.052056156381359645 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 5.624923144225831e-10,
      Labor: 7.380023312381352e-11,
      Overhead: 8.856771609724544e-11,
      'Value Add': 1.1233190272280063e-10,
    },
  },
  c52: {
    name: 'Potassium dihydrogen phosphate (technical grade)',
    cost: 4.818498712536018e-10,
    mass: 4.783919597989951e-10,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.6010302767625318 },
      { n: 'Jordan', p: 0.08132347536283324 },
      { n: 'Turkey', p: 0.04273363485636573 },
      { n: 'Israel', p: 0.0957242664321209 },
      { n: 'Denmark', p: 0.12021052066455364 },
      { n: 'Norway', p: 0.020858720922105473 },
      { n: 'Netherlands', p: 0.038119104999489124 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 2.5572549799011863e-10,
      Labor: 6.407454487597884e-11,
      Overhead: 8.364192320840398e-11,
      'Value Add': 7.840790517910044e-11,
    },
  },
  c53: {
    name: 'Sodium hydroxide (technical grade)',
    cost: 3.600509503370714e-9,
    mass: 1.3155778894472363e-8,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.6451643669217451 },
      { n: 'Egypt', p: 0.0391181241809008 },
      { n: 'Russia', p: 0.03807166577196611 },
      { n: 'Romania', p: 0.036242153384969604 },
      { n: 'Norway', p: 0.11538286934020449 },
      { n: 'Germany', p: 0.07710600264798884 },
      { n: 'United States', p: 0.023494175439642787 },
      { n: 'Switzerland', p: 0.02542064231258237 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.921548805658472e-9,
      Labor: 4.630062010498287e-10,
      Overhead: 6.267890918231002e-10,
      'Value Add': 5.891654048393131e-10,
    },
  },
  c54: {
    name: 'Sulfuric acid (technical grade)',
    cost: 2.257518903836954e-9,
    mass: 1.3155778894472363e-8,
    profile: 'material',
    sources: [
      { n: 'Bulgaria', p: 0.11741269865685514 },
      { n: 'Turkey', p: 0.033729314258746645 },
      { n: 'Rest of World', p: 0.49022153063932994 },
      { n: 'China', p: 0.02074544069665081 },
      { n: 'Germany', p: 0.09212537007671842 },
      { n: 'Finland', p: 0.1654893165658613 },
      { n: 'Sweden', p: 0.02742556516443294 },
      { n: 'Taiwan', p: 0.05285076394140476 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.1899861840722435e-9,
      Labor: 3.121610408431717e-10,
      Overhead: 3.9051043270829906e-10,
      'Value Add': 3.648612462132398e-10,
    },
  },
  c29: {
    name: 'Polystyrene–divinylbenzene cation-exchange chromatography resin (Ca2+-form, industrial grade)',
    cost: 3.389801611002013e-5,
    mass: 2.391959798994975e-6,
    profile: 'material',
    sources: [
      { n: 'Hungary', p: 0.1418207141918049 },
      { n: 'Italy', p: 0.1428171820738887 },
      { n: 'Rest of World', p: 0.4649589041092689 },
      { n: 'Germany', p: 0.13218348866887186 },
      { n: 'Turkey', p: 0.034809638601894545 },
      { n: 'Iceland', p: 0.0582638236200576 },
      { n: 'Sweden', p: 0.025146248734213467 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 2.467809558952564e-5,
      Labor: 2.6889429471388213e-6,
      Overhead: 2.8239424647710516e-6,
      'Value Add': 3.707035108584617e-6,
    },
  },
  c30: {
    name: 'Sodium chloride (technical grade)',
    cost: 6.758498561839958e-7,
    mass: 1.1959798994974876e-5,
    profile: 'material',
    sources: [
      { n: 'Turkey', p: 0.46279771960820326 },
      { n: 'Rest of World', p: 0.33495247422203556 },
      { n: 'Netherlands', p: 0.09142893704539526 },
      { n: 'Germany', p: 0.04844086186406103 },
      { n: 'Israel', p: 0.06238000726030489 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.7044190791676717e-7,
      Labor: 7.253762514247714e-8,
      Overhead: 1.192892597635013e-7,
      'Value Add': 1.135810633612503e-7,
    },
  },
  c31: {
    name: 'Sodium hydroxide (technical grade)',
    cost: 3.310086483424567e-6,
    mass: 1.1959798994974876e-5,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5295414317496372 },
      { n: 'Egypt', p: 0.10682635441833124 },
      { n: 'Russia', p: 0.10396861675279459 },
      { n: 'Romania', p: 0.0741904928929628 },
      { n: 'Turkey', p: 0.02685409371722566 },
      { n: 'Germany', p: 0.0725840424475943 },
      { n: 'United States', p: 0.02162071938100357 },
      { n: 'Switzerland', p: 0.04181450023757621 },
      { n: 'Jordan', p: 0.02259974840287439 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.8103485548907998e-6,
      Labor: 3.6109149279156084e-7,
      Overhead: 5.835761007594808e-7,
      'Value Add': 5.550703349827253e-7,
    },
  },
  c18: {
    name: 'Glucose',
    cost: 0.00857743858631912,
    mass: 0.011959798994974876,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.38018012130599116 },
      { n: 'France', p: 0.2593699514940385 },
      { n: 'Belgium', p: 0.1819333030048912 },
      { n: 'Germany', p: 0.17851662419507913 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.005969206553808625,
      Labor: 0.0006454804271800796,
      Overhead: 0.0008651757602924405,
      'Value Add': 0.0010975758450379746,
    },
  },
  c19: {
    name: 'Mineral salts (inorganic salts)',
    cost: 0.0024387853453789214,
    mass: 0.0035879396984924623,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.26359408649009863 },
      { n: 'Rest of World', p: 0.4134265634337991 },
      { n: 'France', p: 0.2397808894436445 },
      { n: 'Norway', p: 0.08319846063245782 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0012353074416148074,
      Labor: 0.0004112781750978599,
      Overhead: 0.00041344254758565014,
      'Value Add': 0.0003787571810806041,
    },
  },
  c20: {
    name: 'Molasses organic solids',
    cost: 0.0004374419984435978,
    mass: 0.0011959798994974878,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.5664556886419396 },
      { n: 'Rest of World', p: 0.3512721233473183 },
      { n: 'Netherlands', p: 0.08227218801074207 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.00024440939784035523,
      Labor: 7.866747221461769e-6,
      Overhead: 0.00017895510175603452,
      'Value Add': 6.210751625746294e-6,
    },
  },
  c32: {
    name: 'Food-grade molasses (unspecified source)',
    cost: 0.00024440939784035523,
    mass: 0.001758090452261307,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.2066617937759009 },
      { n: 'Rest of World', p: 0.5365437128157932 },
      { n: 'France', p: 0.12526688464663252 },
      { n: 'Belgium', p: 0.09949819980931243 },
      { n: 'Netherlands', p: 0.032029408952361026 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.00015573087101651957,
      Labor: 3.1218333429153765e-5,
      Overhead: 2.531960765677642e-5,
      'Value Add': 3.214058573790548e-5,
    },
  },
  c21: {
    name: 'Organic acids',
    cost: 0.0019104760254760116,
    mass: 0.0011959798994974878,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.35805101867959077 },
      { n: 'Rest of World', p: 0.4083250837691945 },
      { n: 'Belgium', p: 0.15728858228959197 },
      { n: 'United States', p: 0.07633531526162281 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0014383384148557825,
      Labor: 2.9652104886508123e-5,
      Overhead: 0.00040692315533485436,
      'Value Add': 3.556235039886674e-5,
    },
  },
  c40: {
    name: 'Calcium carbonate',
    cost: 0.0002693198234178138,
    mass: 0.000789346733668342,
    profile: 'material',
    sources: [
      { n: 'Belgium', p: 0.2637503062934883 },
      { n: 'Germany', p: 0.07461494837665802 },
      { n: 'Rest of World', p: 0.5596654125747782 },
      { n: 'Slovenia', p: 0.0380686037120984 },
      { n: 'Greece', p: 0.03676098892688099 },
      { n: 'United States', p: 0.027139740116096173 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0001393586325264156,
      Labor: 4.108195124536048e-5,
      Overhead: 4.6150538241993466e-5,
      'Value Add': 4.272870140404426e-5,
    },
  },
  c41: {
    name: 'D-Glucose',
    cost: 0.0009318223961936858,
    mass: 0.0013275376884422116,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5445361815835454 },
      { n: 'France', p: 0.14808867033518433 },
      { n: 'Belgium', p: 0.17977632307481173 },
      { n: 'Germany', p: 0.08251564149483266 },
      { n: 'United States', p: 0.04508318351162601 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0006545547780015872,
      Labor: 6.255918232182946e-5,
      Overhead: 9.435349302944065e-5,
      'Value Add': 0.0001203549428408285,
    },
  },
  c42: {
    name: 'Polypropylene glycol-based antifoam',
    cost: 1.6594520171777122e-6,
    mass: 1.1959798994974878e-6,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.2740443205579603 },
      { n: 'Rest of World', p: 0.5030137978467799 },
      { n: 'Netherlands', p: 0.027494354214236225 },
      { n: 'Belgium', p: 0.13660353092620076 },
      { n: 'United States', p: 0.05884399645482276 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.5047169083611406e-6,
      Labor: 5.156887201083852e-8,
      Overhead: 5.2525465718239286e-8,
      'Value Add': 5.0640771087493805e-8,
    },
  },
  c61: {
    name: 'Deionized water',
    cost: 1.3047159726111353e-8,
    mass: 2.3919597989949755e-8,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.2740443205579603 },
      { n: 'Rest of World', p: 0.5030137978467799 },
      { n: 'Netherlands', p: 0.027494354214236225 },
      { n: 'Belgium', p: 0.13660353092620076 },
      { n: 'United States', p: 0.05884399645482276 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 7.79666018615636e-9,
      Labor: 2.1652060992212634e-9,
      Overhead: 9.590552246861862e-10,
      'Value Add': 2.126238216047544e-9,
    },
  },
  c62: {
    name: 'Ethylene oxide–propylene oxide block copolymer nonionic surfactant',
    cost: 1.6534736516659047e-7,
    mass: 9.567839195979902e-8,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.14930053291177847 },
      { n: 'Netherlands', p: 0.08004944512188407 },
      { n: 'Rest of World', p: 0.5920713281043515 },
      { n: 'Belgium', p: 0.13061197905430005 },
      { n: 'United States', p: 0.047966714807686044 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.0987757872958838e-7,
      Labor: 1.616284460993399e-8,
      Overhead: 1.7363962040865608e-8,
      'Value Add': 2.194297978620248e-8,
    },
  },
  c63: {
    name: 'Hydrophobic fumed silica',
    cost: 8.473302872424042e-8,
    mass: 1.4351758793969852e-7,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.22175696437215583 },
      { n: 'Rest of World', p: 0.632873490877057 },
      { n: 'France', p: 0.02579567385954264 },
      { n: 'China', p: 0.02407880300953707 },
      { n: 'Belgium', p: 0.06003438865375968 },
      { n: 'United States', p: 0.03546067922794763 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 4.428856162766977e-8,
      Labor: 1.227092869248314e-8,
      Overhead: 1.4594238068712818e-8,
      'Value Add': 1.3579300335374695e-8,
    },
  },
  c64: {
    name: 'Polypropylene glycol',
    cost: 1.2415893547441983e-6,
    mass: 9.328643216080404e-7,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.26811417823048844 },
      { n: 'Rest of World', p: 0.6393153002830284 },
      { n: 'Belgium', p: 0.04626376498038906 },
      { n: 'United States', p: 0.046306756506094005 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 8.278276951992767e-7,
      Labor: 1.1776435178324236e-7,
      Overhead: 1.3067689760847705e-7,
      'Value Add': 1.653204101532022e-7,
    },
  },
  c43: {
    name: 'Sulfuric acid',
    cost: 0.0002196319921826874,
    mass: 0.0013155778894472366,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.2408722284334773 },
      { n: 'Rest of World', p: 0.5328635532624063 },
      { n: 'Poland', p: 0.03598249404505381 },
      { n: 'Belgium', p: 0.15035557256799745 },
      { n: 'Canada', p: 0.039926151691065136 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.00011341165814597412,
      Labor: 3.3850782823442004e-5,
      Overhead: 3.759644251662618e-5,
      'Value Add': 3.4773108696645117e-5,
    },
  },
  c44: {
    name: 'Yeast extract',
    cost: 1.5904751044417608e-5,
    mass: 1.7939698492462318e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.2271286899995806 },
      { n: 'Rest of World', p: 0.5609729938932826 },
      { n: 'Netherlands', p: 0.05607782021396423 },
      { n: 'Belgium', p: 0.11770993999857919 },
      { n: 'United States', p: 0.03811055589459341 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 9.169160092178973e-6,
      Labor: 2.4438379612477116e-7,
      Overhead: 6.2679936728421395e-6,
      'Value Add': 2.232134832717251e-7,
    },
  },
  c55: {
    name: 'Ammonium sulfate',
    cost: 8.633966896657678e-7,
    mass: 2.6909547738693475e-6,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.09855360710154148 },
      { n: 'Belgium', p: 0.17061135979311734 },
      { n: 'Rest of World', p: 0.661849188856146 },
      { n: 'China', p: 0.025628417150319948 },
      { n: 'Netherlands', p: 0.043357427098875245 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.829645213457503e-7,
      Labor: 8.590998420204255e-8,
      Overhead: 1.5992556546965048e-7,
      'Value Add': 2.3459661864832448e-7,
    },
  },
  c56: {
    name: 'Diammonium phosphate',
    cost: 6.282699203141236e-7,
    mass: 8.96984924623116e-7,
    profile: 'material',
    sources: [
      { n: 'Russia', p: 0.07165613080619583 },
      { n: 'Rest of World', p: 0.6627213242488603 },
      { n: 'Poland', p: 0.0479541451641414 },
      { n: 'Belgium', p: 0.11294351980796058 },
      { n: 'Germany', p: 0.0234257636855838 },
      { n: 'Netherlands', p: 0.0246669053295847 },
      { n: 'Morocco', p: 0.03523918320121336 },
      { n: 'United States', p: 0.021393027756460146 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 4.3035971747133014e-7,
      Labor: 5.1390397777199895e-8,
      Overhead: 4.4412519492157e-8,
      'Value Add': 1.0210728557343653e-7,
    },
  },
  c57: {
    name: 'Food-grade molasses',
    cost: 7.2080122070229065e-6,
    mass: 4.6643216080402026e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.0828640676304589 },
      { n: 'Rest of World', p: 0.6597306991166634 },
      { n: 'France', p: 0.08804309661456741 },
      { n: 'Belgium', p: 0.11946355958179045 },
      { n: 'Netherlands', p: 0.02183167216308287 },
      { n: 'United States', p: 0.028066904893437085 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 4.650906089596407e-6,
      Labor: 8.452587613866299e-7,
      Overhead: 7.519680144816809e-7,
      'Value Add': 9.598793415581886e-7,
    },
  },
  c58: {
    name: 'Magnesium sulfate',
    cost: 5.408677116756215e-8,
    mass: 1.7939698492462317e-7,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.2848567802504191 },
      { n: 'Rest of World', p: 0.6203441263288363 },
      { n: 'Netherlands', p: 0.031200875352795067 },
      { n: 'China', p: 0.022869918665210928 },
      { n: 'Belgium', p: 0.040728299402738595 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 2.818794021092656e-8,
      Labor: 7.954152066118588e-9,
      Overhead: 9.30198443641183e-9,
      'Value Add': 8.642694454105178e-9,
    },
  },
  c59: {
    name: 'Potassium chloride',
    cost: 6.931279062416615e-8,
    mass: 1.7939698492462317e-7,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.24362200088203576 },
      { n: 'Rest of World', p: 0.643729182077361 },
      { n: 'Canada', p: 0.11264881704060332 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.611268837643366e-8,
      Labor: 1.0208763725209606e-8,
      Overhead: 1.191883981497819e-8,
      'Value Add': 1.1072498707544698e-8,
    },
  },
  c60: {
    name: 'Sodium chloride',
    cost: 3.460817133844481e-7,
    mass: 5.381909547738695e-6,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.19596142564160127 },
      { n: 'Netherlands', p: 0.1458339100650379 },
      { n: 'Rest of World', p: 0.6582046642933608 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 1.806209562472663e-7,
      Labor: 5.051757163005079e-8,
      Overhead: 5.9563057510112394e-8,
      'Value Add': 5.538012799701865e-8,
    },
  },
  c22: {
    name: 'Sucrose',
    cost: 0.5452120251374453,
    mass: 1.1601005025125628,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.5213781177565175 },
      { n: 'Rest of World', p: 0.33434505727113073 },
      { n: 'Poland', p: 0.1043832577902026 },
      { n: 'France', p: 0.0398935671821492 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.3454931154646079,
      Labor: 0.07210457772084752,
      Overhead: 0.05630958019041791,
      'Value Add': 0.07130475176157194,
    },
  },
  c12: {
    name: 'Sulfuric acid, 96% technical grade',
    cost: 0.22564103058468235,
    mass: 0.8,
    profile: 'assembly',
    sources: [{ n: 'Germany', p: 1 }],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 0.22564103058468235 },
  },
  c82: {
    name: 'Elemental sulfur',
    cost: 0.22435858783659074,
    mass: 0.49465648854961836,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.41535861226240284 },
      { n: 'Rest of World', p: 0.3688997268884243 },
      { n: 'Russia', p: 0.13874924685698792 },
      { n: 'China', p: 0.07699241399218495 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.11709247636077846,
      Labor: 0.03275090736045144,
      Overhead: 0.038613521037841755,
      'Value Add': 0.03590168307751908,
    },
  },
  c83: {
    name: 'Water',
    cost: 0.001282442748091603,
    mass: 0.3053435114503817,
    profile: 'material',
    sources: [{ n: 'Germany', p: 1 }],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 0.0006431235622684401,
      Labor: 0.00024035815015939862,
      Overhead: 6.344972438934433e-5,
      'Value Add': 0.00033551131127441996,
    },
  },
  c13: {
    name: 'Zinc sulfate heptahydrate',
    cost: 8.267489305743485e-5,
    mass: 5e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.553975077418917 },
      { n: 'Rest of World', p: 0.26559022097017737 },
      { n: 'Netherlands', p: 0.11295865011497806 },
      { n: 'France', p: 0.06747605149592746 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 8.267489305743485e-5 },
  },
  c67: {
    name: 'Sulfuric acid (98%)',
    cost: 7.567239394714393e-6,
    mass: 2.7549467275494675e-5,
    profile: 'assembly',
    sources: [
      { n: 'Germany', p: 0.553975077418917 },
      { n: 'Rest of World', p: 0.26559022097017737 },
      { n: 'Netherlands', p: 0.11295865011497806 },
      { n: 'France', p: 0.06747605149592746 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 7.567239394714393e-6 },
  },
  c70: {
    name: 'Elemental sulfur',
    cost: 7.527215050951492e-6,
    mass: 1.7094261478342995e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.25077543676572384 },
      { n: 'Rest of World', p: 0.514470116581532 },
      { n: 'Russia', p: 0.07686362476941631 },
      { n: 'China', p: 0.042651878501989975 },
      { n: 'Netherlands', p: 0.0815081105604051 },
      { n: 'France', p: 0.0337308328209327 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 3.936150203990061e-6,
      Labor: 1.0874299355229963e-6,
      Overhead: 1.2967732789817648e-6,
      'Value Add': 1.2068616324566704e-6,
    },
  },
  c71: {
    name: 'Water',
    cost: 4.0024343762901177e-8,
    mass: 1.0455205797151678e-5,
    profile: 'material',
    sources: [
      { n: 'Germany', p: 0.553975077418917 },
      { n: 'Rest of World', p: 0.26559022097017737 },
      { n: 'Netherlands', p: 0.11295865011497806 },
      { n: 'France', p: 0.06747605149592746 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 2.0606559347029814e-8,
      Labor: 6.6472417753085405e-9,
      Overhead: 2.020300924974219e-9,
      'Value Add': 1.0750241715588605e-8,
    },
  },
  c68: {
    name: 'Zinc oxide',
    cost: 7.510765366272045e-5,
    mass: 2.2450532724505327e-5,
    profile: 'assembly',
    sources: [
      { n: 'Rest of World', p: 0.5720620806789691 },
      { n: 'Germany', p: 0.13169189424298136 },
      { n: 'Netherlands', p: 0.17571736853289277 },
      { n: 'Austria', p: 0.09124337624909133 },
      { n: 'Belgium', p: 0.029285280296065305 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: { Materials: 7.510765366272045e-5 },
  },
  c69: {
    name: 'Primary zinc metal, Special High Grade (SHG)',
    cost: 7.510765366272045e-5,
    mass: 2.2450532724505327e-5,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.775070748187805 },
      { n: 'Germany', p: 0.03753709350880793 },
      { n: 'Finland', p: 0.0483286907892667 },
      { n: 'Belgium', p: 0.029750585110798602 },
      { n: 'Netherlands', p: 0.08257652166146666 },
      { n: 'Norway', p: 0.026736360741855068 },
    ],
    rootCost: 2.2132362878918332,
    breakdown: {
      Materials: 5.133331288777805e-5,
      Labor: 3.1201977316229264e-6,
      Overhead: 3.891585080348647e-6,
      'Value Add': 1.6762557962970826e-5,
    },
  },
  s0: {
    name: 'System on chip',
    cost: 7.854219392151086,
    mass: 0.0005,
    profile: 'assembly',
    sources: [{ n: 'Taiwan', p: 1 }],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 5.114023323483046,
      Labor: 1.1400000000000001,
      Overhead: 0.50019606866804,
      'Value Add': 1.1,
    },
  },
  s3: {
    name: 'Epoxy molding compound (epoxy resin)',
    cost: 0.0029308487322292185,
    mass: 0.0003203207943282354,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.9437073658726071 },
      { n: 'Rest of World', p: 0.05629263412739294 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.002128204649119288,
      Labor: 0.00022855133061822343,
      Overhead: 0.000254403199304031,
      'Value Add': 0.0003196895531876759,
    },
  },
  s2: {
    name: 'Epoxy fiberglass substrate (glass fibre-reinforced epoxy resin)',
    cost: 0.2566930642508446,
    mass: 0.00010560026186645123,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.9437073658726071 },
      { n: 'Rest of World', p: 0.05629263412739294 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.000298793992423967,
      Labor: 0.1271694913936173,
      Overhead: 0.024437763497598748,
      'Value Add': 0.10478701536720458,
    },
  },
  s19: {
    name: 'glass fibre (E-glass fibre fabric)',
    cost: 0.00020098872049183634,
    mass: 6.350286017644703e-5,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.9241258804769255 },
      { n: 'Rest of World', p: 0.07587411952307459 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 7.870285528918409e-5,
      Labor: 5.555466992995034e-5,
      Overhead: 2.972355849366695e-5,
      'Value Add': 3.700763677903498e-5,
    },
  },
  s30: {
    name: 'glass fibre (E-glass)',
    cost: 7.870285528918409e-5,
    mass: 6.477291737997598e-5,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.5999286961513733 },
      { n: 'China', p: 0.24971706138776778 },
      { n: 'Rest of World', p: 0.15035424246085888 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 4.106479480827033e-5,
      Labor: 1.4003736260577799e-5,
      Overhead: 8.428845756880804e-6,
      'Value Add': 1.5205478463455148e-5,
    },
  },
  s18: {
    name: 'epoxy resin',
    cost: 9.780527193213065e-5,
    mass: 4.20974016900042e-5,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8905835924022146 },
      { n: 'Rest of World', p: 0.10941640759778534 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 7.136522376803293e-5,
      Labor: 7.5622171180726846e-6,
      Overhead: 8.157660639019147e-6,
      'Value Add': 1.0720170407005895e-5,
    },
  },
  s4: {
    name: 'Silicon die (silicon)',
    cost: 4.819623941268355,
    mass: 4.225771273642583e-5,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.009442455268672004,
      Labor: 1.8271199475513562,
      Overhead: 0.524761225085528,
      'Value Add': 2.4583003133627996,
    },
  },
  s8: {
    name: 'Monocrystalline silicon substrate (silicon)',
    cost: 0.009403055780308776,
    mass: 4.208868188548013e-5,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.004157567916745747,
      Labor: 0.0018708693238544947,
      Overhead: 0.0008574555853792412,
      'Value Add': 0.0025171629543292925,
    },
  },
  s9: {
    name: 'Silicon dioxide passivation layer (silicon dioxide)',
    cost: 4.261687592534289e-6,
    mass: 1.0564428184106457e-7,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.3383998564905279e-6,
      Labor: 1.108775560018293e-6,
      Overhead: 3.227090186603054e-7,
      'Value Add': 1.4918031573651626e-6,
    },
  },
  s14: {
    name: 'tetraethyl orthosilicate (TEOS)',
    cost: 1.313246727776155e-6,
    mass: 3.665856579884941e-7,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.35853995697209456 },
      { n: 'Germany', p: 0.22655807782070345 },
      { n: 'Taiwan', p: 0.13437189139213185 },
      { n: 'Rest of World', p: 0.2805300738150702 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 8.923371963704684e-7,
      Labor: 1.0272113803138804e-7,
      Overhead: 1.399851849597594e-7,
      'Value Add': 1.7820320841453923e-7,
    },
  },
  s13: {
    name: 'deionized water',
    cost: 2.515312871437281e-8,
    mass: 6.338656910463874e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.5420660702412484e-8,
      Labor: 3.642671530817821e-9,
      Overhead: 1.8844063115940197e-9,
      'Value Add': 4.205390169548483e-9,
    },
  },
  s7: {
    name: 'Aluminum interconnect layer (aluminum wrought alloy)',
    cost: 1.2902424288860663e-7,
    mass: 4.225771273642583e-8,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.3594415087495057 },
      { n: 'Rest of World', p: 0.38417562399780825 },
      { n: 'China', p: 0.18466862170169454 },
      { n: 'Japan', p: 0.07171424555099166 },
    ],
    rootCost: 7.854219392151086,
    breakdown: { Materials: 1.2902424288860663e-7 },
  },
  s29: {
    name: 'aluminum wrought alloy',
    cost: 1.2902424288860663e-7,
    mass: 4.310286699115435e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.15532570618579425 },
      { n: 'Rest of World', p: 0.5119747242322047 },
      { n: 'China', p: 0.2557198084023481 },
      { n: 'Japan', p: 0.0769797611796531 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 8.695029189494427e-8,
      Labor: 1.2644829277297545e-8,
      Overhead: 6.615879899473616e-9,
      'Value Add': 2.281324181689119e-8,
    },
  },
  s10: {
    name: 'Silicon nitride passivation layer (silicon nitride)',
    cost: 3.500877652780446e-5,
    mass: 2.1128856368212916e-8,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.3574406769453159e-5,
      Labor: 7.891244155468453e-6,
      Overhead: 2.9258434664755467e-6,
      'Value Add': 1.0617282136407299e-5,
    },
  },
  s12: {
    name: 'Dichlorosilane (SiH2Cl2, technical grade ~98%)',
    cost: 4.492939424485043e-8,
    mass: 3.840592222050062e-8,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.7962725363783374e-8,
      Labor: 8.742667118387758e-9,
      Overhead: 8.084614531156609e-9,
      'Value Add': 1.0139387231522692e-8,
    },
  },
  s24: {
    name: 'Hydrogen chloride gas (HCl, ≥99% purity)',
    cost: 1.8057439002064155e-9,
    mass: 2.7721394658757346e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 9.507235275807128e-10,
      Labor: 2.5134618211623836e-10,
      Overhead: 3.1217318342190006e-10,
      'Value Add': 2.915010070875642e-10,
    },
  },
  s25: {
    name: 'Metallurgical grade silicon powder (Si)',
    cost: 1.6156981463576957e-8,
    mass: 1.0696049338409423e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 9.443786831191058e-9,
      Labor: 2.7351462680353085e-9,
      Overhead: 8.758054330018972e-10,
      'Value Add': 3.1022429313486947e-9,
    },
  },
  s11: {
    name: 'Ammonia (NH3, anhydrous, ≥99.999% purity)',
    cost: 1.3529477375208308e-5,
    mass: 1.025805976676737e-8,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 4.668634991106241e-6,
      Labor: 1.8670385110846736e-6,
      Overhead: 1.7287018801273805e-6,
      'Value Add': 5.265101992890013e-6,
    },
  },
  s40: {
    name: 'Liquid nitrogen (LN2)',
    cost: 1.1801521600157302e-8,
    mass: 5.129029883383685e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 4.9064441673195395e-9,
      Labor: 1.579551490350088e-9,
      Overhead: 2.487095704207233e-9,
      'Value Add': 2.828430238280441e-9,
    },
  },
  s43: {
    name: 'Technical-grade ammonia gas (NH3, 99.9% purity)',
    cost: 5.40664388718538e-9,
    mass: 1.0463220962102717e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.8465961026976197e-9,
      Labor: 7.525648011054072e-10,
      Overhead: 9.346891514894675e-10,
      'Value Add': 8.727938318928851e-10,
    },
  },
  s38: {
    name: 'Activated carbon',
    cost: 3.875181572859834e-10,
    mass: 2.0516119533534739e-10,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.38616997907661266 },
      { n: 'Rest of World', p: 0.4207556335888175 },
      { n: 'India', p: 0.08126058051742346 },
      { n: 'Indonesia', p: 0.06939300677126731 },
      { n: 'Taiwan', p: 0.04242080004587903 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.7073327214587623e-10,
      Labor: 2.0627814820627706e-11,
      Overhead: 4.209058299025259e-11,
      'Value Add': 5.4066487329226855e-11,
    },
  },
  s42: {
    name: 'SAES getter alloy (Zr–V–Fe)',
    cost: 3.158517347581944e-9,
    mass: 1.0258059766767369e-10,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.8317888994985762 },
      { n: 'Rest of World', p: 0.16821110050142385 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.9795736591863523e-9,
      Labor: 2.1888595589162985e-10,
      Overhead: 2.3896291742691403e-10,
      'Value Add': 7.210948150770478e-10,
    },
  },
  s39: {
    name: 'Copper catalyst bed (Cu on Al2O3)',
    cost: 3.6547407464488933e-6,
    mass: 5.1290298833836847e-11,
    profile: 'material',
    sources: [
      { n: 'United States', p: 0.25086770497308475 },
      { n: 'Rest of World', p: 0.3944658772742904 },
      { n: 'Japan', p: 0.17721361289717463 },
      { n: 'Belgium', p: 0.1211760842419211 },
      { n: 'Taiwan', p: 0.056276720613529174 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.2040518860071786e-6,
      Labor: 5.7914355297163e-7,
      Overhead: 2.7047520331175205e-7,
      'Value Add': 6.010701041583327e-7,
    },
  },
  s41: {
    name: 'Palladium catalyst bed (Pd on Al2O3)',
    cost: 9.93110693516498e-7,
    mass: 2.051611953353474e-11,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.4494921974545247 },
      { n: 'United States', p: 0.3033583045230101 },
      { n: 'Rest of World', p: 0.24714949802246525 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 6.758575084442351e-7,
      Labor: 4.5213338640650105e-8,
      Overhead: 5.134299242625052e-8,
      'Value Add': 2.2069685400536228e-7,
    },
  },
  s6: {
    name: 'Tin-silver-copper solder (solder alloy)',
    cost: 0.0034519012215178425,
    mass: 2.8160069831053664e-5,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.43328961543866223 },
      { n: 'Taiwan', p: 0.2934235795587616 },
      { n: 'Rest of World', p: 0.20148836011054372 },
      { n: 'Japan', p: 0.07179844489203241 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.002083257842332464,
      Labor: 0.00043620551203640113,
      Overhead: 0.0002480967197813456,
      'Value Add': 0.0006843411473676318,
    },
  },
  s1: {
    name: 'Copper bond wires (copper)',
    cost: 0.02756324438976621,
    mass: 2.816006983105366e-6,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.7988762537457155 },
      { n: 'Malaysia', p: 0.12679354113260027 },
      { n: 'Rest of World', p: 0.07433020512168431 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.0002950284534011575,
      Labor: 0.004668572054051632,
      Overhead: 0.0014470213274057325,
      'Value Add': 0.02115262255490769,
    },
  },
  s20: {
    name: 'copper (wire, ≥99.9% purity)',
    cost: 0.0002950284534011575,
    mass: 2.872327122767473e-6,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.6029362481939883 },
      { n: 'Malaysia', p: 0.21177503861378083 },
      { n: 'Rest of World', p: 0.185288713192231 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.00015718581277730556,
      Labor: 2.215736608397507e-5,
      Overhead: 7.773864000453623e-6,
      'Value Add': 0.00010791141053942326,
    },
  },
  s47: {
    name: 'deionized water, electrolyte bath fill',
    cost: 8.573842594357887e-6,
    mass: 2.1513730149528375e-5,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.6029362481939883 },
      { n: 'Malaysia', p: 0.21177503861378083 },
      { n: 'Rest of World', p: 0.185288713192231 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 5.335988527651984e-6,
      Labor: 1.1330925103028415e-6,
      Overhead: 6.495765852752984e-7,
      'Value Add': 1.4551849711277623e-6,
    },
  },
  s45: {
    name: 'copper sulfate pentahydrate (CuSO4·5H2O, technical grade), initial electrolyte charge',
    cost: 0.0001003402229475674,
    mass: 5.744654245534946e-6,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.597144091899223 },
      { n: 'Rest of World', p: 0.34150351638509124 },
      { n: 'Malaysia', p: 0.03685079866416456 },
      { n: 'United States', p: 0.02450159305152126 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.7957177192370704e-5,
      Labor: 2.4900046801470287e-5,
      Overhead: 1.6923876584975295e-5,
      'Value Add': 3.055912236875111e-5,
    },
  },
  s56: {
    name: 'Sulfuric acid (98%)',
    cost: 6.113905187643213e-7,
    mass: 3.1982921500508313e-6,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.4426267244107113 },
      { n: 'Japan', p: 0.15749561545119628 },
      { n: 'Rest of World', p: 0.3767687873379278 },
      { n: 'South Korea', p: 0.023108872800164628 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 3.2287047869297917e-7,
      Labor: 8.366565741776385e-8,
      Overhead: 1.0585917850906199e-7,
      'Value Add': 9.899520414451632e-8,
    },
  },
  s55: {
    name: 'Copper(II) oxide',
    cost: 2.7345786673606384e-5,
    mass: 2.5463620954841155e-6,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.36755062512348075 },
      { n: 'Vietnam', p: 0.1707461332425364 },
      { n: 'Rest of World', p: 0.4332989011066122 },
      { n: 'United States', p: 0.028404340527370734 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.482055082345176e-5,
      Labor: 3.1826884504638245e-6,
      Overhead: 4.7984235137255936e-6,
      'Value Add': 4.544123885965205e-6,
    },
  },
  s48: {
    name: 'impure copper anodes (scrap copper, ~99.5% Cu, technical grade)',
    cost: 4.085073281118225e-5,
    mass: 3.3031761911825937e-6,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.5529130310078021 },
      { n: 'Rest of World', p: 0.24438318414366522 },
      { n: 'Malaysia', p: 0.2027037848485328 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.8011969798310403e-5,
      Labor: 1.5714170850961424e-6,
      Overhead: 2.1202201923361357e-6,
      'Value Add': 9.14712573543957e-6,
    },
  },
  s49: {
    name: 'sulfuric acid (H2SO4, 98%, technical grade), initial electrolyte charge',
    cost: 2.9165387205030334e-7,
    mass: 1.4648868326114113e-6,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.4469200988287228 },
      { n: 'Japan', p: 0.1812738161430928 },
      { n: 'Rest of World', p: 0.21806957974520944 },
      { n: 'South Korea', p: 0.13280261505797034 },
      { n: 'Philippines', p: 0.020933890225004737 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.5293134678054096e-7,
      Labor: 4.151649810583346e-8,
      Overhead: 5.0315800606449975e-8,
      'Value Add': 4.689022655747896e-8,
    },
  },
  s46: {
    name: 'copper sulfate pentahydrate (CuSO4·5H2O, technical grade), net make-up for electrolyte',
    cost: 7.1005316418497815e-6,
    mass: 5.744654245534946e-7,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.597144091899223 },
      { n: 'Rest of World', p: 0.34150351638509124 },
      { n: 'Malaysia', p: 0.03685079866416456 },
      { n: 'United States', p: 0.02450159305152126 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.9719704215300936e-6,
      Labor: 1.7563345343969143e-6,
      Overhead: 1.216727044294406e-6,
      'Value Add': 2.155499641628368e-6,
    },
  },
  s54: {
    name: 'Sulfuric acid (technical grade)',
    cost: 4.4914624198748434e-8,
    mass: 2.3495635864237928e-7,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.4426267244107113 },
      { n: 'Japan', p: 0.15749561545119628 },
      { n: 'Rest of World', p: 0.3767687873379278 },
      { n: 'South Korea', p: 0.023108872800164628 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.3719056430044586e-8,
      Labor: 6.146336009356162e-9,
      Overhead: 7.776740192720517e-9,
      'Value Add': 7.272491566627163e-9,
    },
  },
  s53: {
    name: 'Process water',
    cost: 1.1748962756936487e-8,
    mass: 2.1599899963211398e-7,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.597144091899223 },
      { n: 'Rest of World', p: 0.34150351638509124 },
      { n: 'Malaysia', p: 0.03685079866416456 },
      { n: 'United States', p: 0.02450159305152126 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 7.261931594557345e-9,
      Labor: 1.6210493493268434e-9,
      Overhead: 8.855701867912224e-10,
      'Value Add': 1.980411626261077e-9,
    },
  },
  s51: {
    name: 'Copper metal (bulk, refined)',
    cost: 1.907218326405691e-6,
    mass: 1.5510566462944356e-7,
    profile: 'material',
    sources: [
      { n: 'Japan', p: 0.21189518110956393 },
      { n: 'Chile', p: 0.18263747000680997 },
      { n: 'China', p: 0.12486720514719474 },
      { n: 'Rest of World', p: 0.48060014373643145 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.3108738411754344e-6,
      Labor: 6.917936581191107e-8,
      Overhead: 9.910783052131192e-8,
      'Value Add': 4.2805728889703366e-7,
    },
  },
  s52: {
    name: 'Oxygen gas (from air)',
    cost: 8.088508168717618e-9,
    mass: 3.906364886963764e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.597144091899223 },
      { n: 'Rest of World', p: 0.34150351638509124 },
      { n: 'Malaysia', p: 0.03685079866416456 },
      { n: 'United States', p: 0.02450159305152126 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 3.392111513178755e-9,
      Labor: 1.0319629372733812e-9,
      Overhead: 1.708974642750201e-9,
      'Value Add': 1.9554590755152817e-9,
    },
  },
  s50: {
    name: 'sulfuric acid (H2SO4, 98%, technical grade), net make-up for electrolyte',
    cost: 2.882891029794665e-8,
    mass: 1.4361635613837366e-7,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.6029362481939883 },
      { n: 'Malaysia', p: 0.21177503861378083 },
      { n: 'Rest of World', p: 0.185288713192231 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.5415276380024847e-8,
      Labor: 3.6635558664127755e-9,
      Overhead: 5.0236055713916186e-9,
      'Value Add': 4.726472480117408e-9,
    },
  },
  s5: {
    name: 'Silver epoxy die attach (silver-filled epoxy adhesive)',
    cost: 0.00376032362033277,
    mass: 8.451542547285166e-7,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.7181541512490682 },
      { n: 'China', p: 0.26634044818821234 },
      { n: 'Rest of World', p: 0.015505400562719429 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.0015394413537660216,
      Labor: 0.0007353464083072673,
      Overhead: 0.00022811865342358222,
      'Value Add': 0.0012574172048358985,
    },
  },
  s17: {
    name: 'Silver powder (99.9% Ag)',
    cost: 0.0015389014512333142,
    mass: 6.761234037828133e-7,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.4560733387621792 },
      { n: 'Hong Kong', p: 0.2418802655436848 },
      { n: 'Rest of World', p: 0.045907856205907656 },
      { n: 'China', p: 0.2561385394882283 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 0.001059689601298407,
      Labor: 5.3131646266255805e-5,
      Overhead: 8.004548731682194e-5,
      'Value Add': 0.0003460347163518295,
    },
  },
  s16: {
    name: 'Diglycidyl ether of bisphenol A (DGEBA, technical grade)',
    cost: 4.2431032747115693e-7,
    mass: 1.2677313820927748e-7,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.7482640786175084 },
      { n: 'Rest of World', p: 0.12148113070118172 },
      { n: 'China', p: 0.09741345823735785 },
      { n: 'South Korea', p: 0.03284133244395203 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.4077005370520505e-7,
      Labor: 5.019926379385931e-8,
      Overhead: 5.4394375878207466e-8,
      'Value Add': 7.894663409388513e-8,
    },
  },
  s21: {
    name: 'Bisphenol A (technical grade, ~98% purity)',
    cost: 1.218490503308325e-7,
    mass: 8.493800260021592e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.6690795970740228 },
      { n: 'Rest of World', p: 0.21242462799382514 },
      { n: 'China', p: 0.08699846589655172 },
      { n: 'South Korea', p: 0.03149730903560039 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 8.223739039549266e-8,
      Labor: 1.0258946188360214e-8,
      Overhead: 1.2929587063788499e-8,
      'Value Add': 1.6423126683191134e-8,
    },
  },
  s22: {
    name: 'Epichlorohydrin (≥99% purity)',
    cost: 1.1288797933583947e-7,
    mass: 6.896458718584695e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.4746363949409451 },
      { n: 'China', p: 0.2796189307013231 },
      { n: 'Rest of World', p: 0.24574467435773187 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 7.718415118082301e-8,
      Labor: 8.206130699063298e-9,
      Overhead: 1.2083722295978873e-8,
      'Value Add': 1.5413975159974295e-8,
    },
  },
  s23: {
    name: 'Sodium hydroxide (NaOH, ≥96% purity)',
    cost: 6.033024038533102e-9,
    mass: 2.9791687479180206e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.6124376758869128 },
      { n: 'Rest of World', p: 0.2574231080947682 },
      { n: 'China', p: 0.09737456501761917 },
      { n: 'South Korea', p: 0.03276465100069985 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 3.2165737573718913e-9,
      Labor: 7.80501269006146e-10,
      Overhead: 1.0497164614246572e-9,
      'Value Add': 9.862325507304067e-10,
    },
  },
  s15: {
    name: '4,4′-Methylenedianiline (MDA, technical grade)',
    cost: 1.1559220523617263e-7,
    mass: 4.225771273642583e-8,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.7181541512490682 },
      { n: 'China', p: 0.26634044818821234 },
      { n: 'Rest of World', p: 0.015505400562719429 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 6.367554659295182e-8,
      Labor: 1.1693207334895414e-8,
      Overhead: 1.998212741561173e-8,
      'Value Add': 2.0241323892713675e-8,
    },
  },
  s26: {
    name: 'Aniline (technical grade, ≈98 % purity)',
    cost: 5.113613550935061e-8,
    mass: 3.9679992259503856e-8,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.5804914562466552 },
      { n: 'South Korea', p: 0.1472975152127763 },
      { n: 'Rest of World', p: 0.23569580627511388 },
      { n: 'China', p: 0.03651522226545472 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 3.438494571966042e-8,
      Labor: 1.4059374851124716e-9,
      Overhead: 4.520565159702044e-9,
      'Value Add': 1.0824687144875674e-8,
    },
  },
  s27: {
    name: 'Formaldehyde (formalin, 37 wt% aqueous solution)',
    cost: 1.233295907135326e-8,
    mass: 1.732566222193459e-8,
    profile: 'assembly',
    sources: [
      { n: 'Taiwan', p: 0.5307738866450189 },
      { n: 'China', p: 0.420658528945988 },
      { n: 'Rest of World', p: 0.04856758440899309 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 7.35838780066316e-9,
      Labor: 1.2181071692709586e-9,
      Overhead: 1.3437057858392006e-9,
      'Value Add': 2.412758315579941e-9,
    },
  },
  s31: {
    name: 'Compressed air',
    cost: 1.7440303939012404e-10,
    mass: 9.529114222064026e-9,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.5307738866450189 },
      { n: 'China', p: 0.420658528945988 },
      { n: 'Rest of World', p: 0.04856758440899309 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.0944251452477724e-10,
      Labor: 2.8558413013769518e-11,
      Overhead: 7.095793184198692e-12,
      'Value Add': 2.930631866737859e-11,
    },
  },
  s32: {
    name: 'Demineralized water',
    cost: 3.1776095422448054e-9,
    mass: 8.836087733186642e-9,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.5307738866450189 },
      { n: 'China', p: 0.420658528945988 },
      { n: 'Rest of World', p: 0.04856758440899309 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.0207513659007706e-9,
      Labor: 3.6110493241623486e-10,
      Overhead: 2.446712836113208e-10,
      'Value Add': 5.510819603164792e-10,
    },
  },
  s34: {
    name: 'Methanol',
    cost: 3.762602078057426e-9,
    mass: 7.2767781332125275e-9,
    profile: 'material',
    sources: [
      { n: 'United States', p: 0.2594265692558813 },
      { n: 'Bahrain', p: 0.16235521422704446 },
      { n: 'Malaysia', p: 0.09111144387643613 },
      { n: 'Rest of World', p: 0.18912509498042182 },
      { n: 'Oman', p: 0.1478600985031058 },
      { n: 'Iran', p: 0.08256612811067367 },
      { n: 'Saudi Arabia', p: 0.06755545104643682 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.5311686948832684e-9,
      Labor: 1.0192409881611795e-10,
      Overhead: 3.3267483662039024e-10,
      'Value Add': 7.968344477376495e-10,
    },
  },
  s33: {
    name: 'Iron(III) oxide / Molybdenum trioxide catalyst (Fe2O3/MoO3, unrecovered loss)',
    cost: 2.437731409708042e-10,
    mass: 5.1976986665803765e-12,
    profile: 'material',
    sources: [
      { n: 'Taiwan', p: 0.25520332196558954 },
      { n: 'China', p: 0.5059489026660269 },
      { n: 'Rest of World', p: 0.19281060166893937 },
      { n: 'Japan', p: 0.046037173699444295 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.350667958734414e-10,
      Labor: 2.402351488855446e-11,
      Overhead: 4.327004733449777e-11,
      'Value Add': 4.141278287431052e-11,
    },
  },
  s28: {
    name: 'p-Toluenesulfonic acid (catalyst, ≥99 % purity; 5 % unrecovered loss)',
    cost: 2.0645201224796206e-10,
    mass: 1.8170816476663105e-11,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.5638394104443356 },
      { n: 'Germany', p: 0.19560687114727016 },
      { n: 'Taiwan', p: 0.11601469035307028 },
      { n: 'Rest of World', p: 0.1245390280553239 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 9.913926853259921e-11,
      Labor: 1.6329768123536728e-11,
      Overhead: 5.847597799501774e-11,
      'Value Add': 3.25069975968084e-11,
    },
  },
  s36: {
    name: 'Ethanol',
    cost: 6.983670702288316e-11,
    mass: 7.95881761677844e-11,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5214568915209922 },
      { n: 'Rest of World', p: 0.2438270212297101 },
      { n: 'Netherlands', p: 0.05967946715390991 },
      { n: 'Germany', p: 0.05088436011650122 },
      { n: 'Hungary', p: 0.029650150496081454 },
      { n: 'Pakistan', p: 0.06905003737070231 },
      { n: 'Australia', p: 0.02545207211210285 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 5.512974811533416e-11,
      Labor: 9.106443687757948e-13,
      Overhead: 5.75105569013071e-12,
      'Value Add': 8.045258848642492e-12,
    },
  },
  s37: {
    name: 'Technical grade p-Toluenesulfonic acid',
    cost: 2.913256629157806e-11,
    mass: 2.1804979771995727e-11,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5642003673522306 },
      { n: 'Rest of World', p: 0.3071690091766017 },
      { n: 'Germany', p: 0.12863062347116766 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 2.0165355028932982e-11,
      Labor: 1.795664072808652e-12,
      Overhead: 3.1444473674928013e-12,
      'Value Add': 4.027099822343624e-12,
    },
  },
  s35: {
    name: 'Activated carbon',
    cost: 1.699952181379978e-13,
    mass: 9.085408238331552e-14,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5790835610398725 },
      { n: 'Rest of World', p: 0.32556661733912456 },
      { n: 'Germany', p: 0.07391688196770699 },
      { n: 'Philippines', p: 0.02143293965329595 },
    ],
    rootCost: 7.854219392151086,
    breakdown: {
      Materials: 1.1832980253447034e-13,
      Labor: 9.616212016022033e-15,
      Overhead: 1.841828183676965e-14,
      'Value Add': 2.3630921750735782e-14,
    },
  },
  n0: {
    name: 'NMC Battery Cell',
    cost: 32.942205761980844,
    mass: 1.2,
    profile: 'assembly',
    sources: [{ n: 'China', p: 1 }],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 23.472738762441605,
      Labor: 3.012227675137262,
      Overhead: 1.5689100532591842,
      'Value Add': 4.888329271142795,
    },
    steps: [
      {
        p: 'Roll winding',
        o: 'Wind anode sheet, cathode foil, and separator film into a jellyroll',
        c: 0.6919714528976206,
        e: 0.19963152139434728,
      },
      {
        p: 'Electrode assembly',
        o: 'Insert jellyroll into can with insulator and attach tabs',
        c: 0.08772532904418913,
        e: 0.0017863700479174543,
      },
      {
        p: 'Liquid filling',
        o: 'Fill cell with measured electrolyte via vacuum-assisted pump',
        c: 0.0019508475680051513,
        e: 0.0186492960148602,
      },
      {
        p: 'Mechanical assembly',
        o: 'Press-fit and crimp cap and vent assembly onto filled can',
        c: 0.053534405516301,
        e: 0.000556487852944483,
      },
      {
        p: 'Electrochemical Conditioning',
        o: 'Formation cycling to build SEI layer and activate cell',
        c: 0.45914520098668504,
        e: 0.19527861021963475,
      },
      {
        p: 'Integrity Testing',
        o: 'Leak and electrical performance testing of sealed cell',
        c: 0.20910430022243592,
        e: 0.0064459040582953795,
      },
      {
        p: 'Labeling',
        o: 'Apply shrink sleeve label to exterior of finished cell',
        c: 0.00011430531597134189,
        e: 0.0001724471430949015,
      },
    ],
  },
  n1: {
    name: 'Cathode coated foil (nickel manganese cobalt oxide (NMC))',
    cost: 11.813636682999231,
    mass: 0.33456521775000003,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.9016921826377953 },
      { n: 'Rest of World', p: 0.09830781736220473 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 5.385059464436796,
      Labor: 2.6352565361163918,
      Overhead: 1.0120909127426352,
      'Value Add': 2.7812297697034083,
    },
    steps: [
      {
        p: 'Planetary Mixing',
        o: 'Disperse NMC, carbon black, and PVDF binder into a uniform electrode slurry in solvent (typically NMP)',
        c: 0.5090849422262353,
        e: 0.04041604673912358,
      },
      {
        p: 'Roll-to-roll coating',
        o: 'Apply NMC slurry onto aluminum foil current collector via slot-die (roll-to-roll) coating',
        c: 0.06429510009452942,
        e: 0.21985745343489224,
      },
      {
        p: 'Atmospheric drying',
        o: 'Remove NMP solvent from coated electrode in a conveyorized drying oven',
        c: 0.2406750215911285,
        e: 0.0754365735832164,
      },
      {
        p: 'Calendering',
        o: 'Compress dried electrode coating between rollers to densify the active layer (calendering)',
        c: 0.02261656982649295,
        e: 1.9728987000986846e-5,
      },
    ],
  },
  n12: {
    name: 'Lithium nickel manganese cobalt oxide (NMC cathode active material)',
    cost: 4.989390004533226,
    mass: 0.25426956549000007,
    profile: 'material',
    sources: [
      { n: 'Malaysia', p: 0.4594817867383014 },
      { n: 'China', p: 0.317453756667796 },
      { n: 'Rest of World', p: 0.22306445659390262 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 2.811061213117881,
      Labor: 0.42299153837127523,
      Overhead: 0.893438761172482,
      'Value Add': 0.8618984918715877,
    },
  },
  n10: {
    name: 'Aluminum foil (aluminum wrought alloy)',
    cost: 0.3255908920264834,
    mass: 0.060221739195000006,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.8570747207070686 },
      { n: 'Rest of World', p: 0.1429252792929314 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.19980569765797446,
      Labor: 0.019133069713309518,
      Overhead: 0.018660443487791906,
      'Value Add': 0.08799168116740748,
    },
    steps: [
      {
        p: 'Sheet rolling',
        o: 'Cold roll aluminum alloy strip through multiple passes to foil gauge',
        c: 0.009179893008255939,
        e: 0.025970042173429287,
      },
      {
        p: 'Rotary slitting',
        o: 'Slit wide master foil roll into finished-width rolls',
        c: 0.007900962607090943,
        e: 0.0010202701374263348,
      },
    ],
  },
  n17: {
    name: 'aluminum wrought alloy',
    cost: 0.19980569765797446,
    mass: 0.0614261739789,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.7728175755980354 },
      { n: 'Rest of World', p: 0.2271824244019645 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.13976156417295044,
      Labor: 0.012863337441181219,
      Overhead: 0.010511403788819637,
      'Value Add': 0.036669392255023164,
    },
  },
  n11: {
    name: 'Carbon black',
    cost: 0.012604396918253815,
    mass: 0.010036956532500002,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.8004193848004879 },
      { n: 'Rest of World', p: 0.19958061519951206 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.007217863069935845,
      Labor: 0.0008968972107331482,
      Overhead: 0.0022765701751817306,
      'Value Add': 0.0022130664624030916,
    },
  },
  n13: {
    name: 'Polyvinylidene fluoride (PVDF)',
    cost: 0.05747417095883331,
    mass: 0.010036956532500002,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.558811729330456 },
      { n: 'Rest of World', p: 0.26801728009041925 },
      { n: 'Japan', p: 0.11601617606950396 },
      { n: 'United States', p: 0.05715481450962087 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.03981295936218772,
      Labor: 0.0037760148815872297,
      Overhead: 0.005493888546226728,
      'Value Add': 0.008391308168831631,
    },
    steps: [
      {
        p: 'Gas-phase catalytic oxidation',
        o: 'Fluorination/halogen exchange of 1,1,1-trichloroethane with HF to form 1-chloro-1,1-difluoroethane intermediate',
        c: 0.00012250368419856517,
        e: 0.005543772057200264,
      },
      {
        p: 'Base-catalyzed ring-opening polymerization',
        o: 'Dehydrochlorination of chlorofluoroethane intermediate with calcium hydroxide to generate VDF monomer',
        c: 0.0010516769784191277,
        e: 0.0017005050789296577,
      },
      {
        p: 'Vapor-liquid separation',
        o: 'Separation and purification of VDF monomer gas from reaction byproducts',
        c: 3.286243323510726e-5,
        e: 5.6549546408623314e-5,
      },
      {
        p: 'Emulsion polymerization',
        o: 'Free-radical emulsion polymerization of VDF monomer to form PVDF latex',
        c: 0.0009680366305256463,
        e: 0.005028420053200272,
      },
      {
        p: 'Centrifugation',
        o: 'Separation of PVDF polymer solids from aqueous emulsion',
        c: 0.00028573506770125727,
        e: 0.00016027272443132017,
      },
      {
        p: 'Solid-liquid washing',
        o: 'Washing PVDF filter cake to remove residual surfactant and salts',
        c: 0.00033377804297446694,
        e: 0.0001156098926777895,
      },
      {
        p: 'Spray Drying',
        o: 'Drying washed PVDF solids into final polymer powder product',
        c: 0.0015027749024892607,
        e: 0.005439396462017755,
      },
    ],
  },
  n18: {
    name: '1,1,1-Trichloroethane',
    cost: 0.03736753372176292,
    mass: 0.027521334812115005,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.45662906211390936 },
      { n: 'Poland', p: 0.08112732574254652 },
      { n: 'Rest of World', p: 0.33179435641557625 },
      { n: 'Japan', p: 0.07688322636041377 },
      { n: 'Germany', p: 0.028294936654074326 },
      { n: 'Brazil', p: 0.02527109271347983 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.018534820837887662,
      Labor: 0.0024483187454240564,
      Overhead: 0.010577284572768532,
      'Value Add': 0.005807109565682667,
    },
    steps: [
      {
        p: 'Gas-phase catalytic oxidation',
        o: 'Hydrochlorination of ethylene with HCl to form vinyl chloride intermediate',
        c: 0.0026638326718970307,
        e: 0.02470560847097236,
      },
      {
        p: 'Gas-phase chlorination',
        o: 'Catalytic chlorination of vinyl chloride intermediate with Cl2 over FeCl3 to form 1,1,1-trichloroethane',
        c: 0.004071711349239115,
        e: 0.021697098900096037,
      },
      {
        p: 'Gas absorption',
        o: 'Absorb and scrub HCl by-product gas from reactor effluent stream',
        c: 0.00029566886611399814,
        e: 0.009158342988055646,
      },
      {
        p: 'Fractional distillation',
        o: 'Distill crude product to separate 1,1,1-trichloroethane from lights and heavies',
        c: 0.001725319353381254,
        e: 0.0067908488866421654,
      },
    ],
  },
  n31: {
    name: 'Chlorine gas (Cl2)',
    cost: 0.013198055730387761,
    mass: 0.03726388733560372,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.45662906211390936 },
      { n: 'Poland', p: 0.08112732574254652 },
      { n: 'Rest of World', p: 0.33179435641557625 },
      { n: 'Japan', p: 0.07688322636041377 },
      { n: 'Germany', p: 0.028294936654074326 },
      { n: 'Brazil', p: 0.02527109271347983 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.007360946064435625,
      Labor: 0.0012293950376802486,
      Overhead: 0.0023507775391473475,
      'Value Add': 0.0022569370891245386,
    },
  },
  n32: {
    name: 'Ethylene (C2H4, feedstock)',
    cost: 0.005256772203454449,
    mass: 0.007403239064458937,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.2640633270783976 },
      { n: 'South Korea', p: 0.1484300477421082 },
      { n: 'Rest of World', p: 0.4598432189828219 },
      { n: 'Russia', p: 0.05197720789161245 },
      { n: 'Japan', p: 0.07568619830505999 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.003557899329389783,
      Labor: 0.00011304547889071453,
      Overhead: 0.0004657689996306209,
      'Value Add': 0.0011200583955433313,
    },
  },
  n33: {
    name: 'Hydrogen chloride (HCl)',
    cost: 2.8769925474725245e-5,
    mass: 0.0003852986873696101,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.45662906211390936 },
      { n: 'Poland', p: 0.08112732574254652 },
      { n: 'Rest of World', p: 0.33179435641557625 },
      { n: 'Japan', p: 0.07688322636041377 },
      { n: 'Germany', p: 0.028294936654074326 },
      { n: 'Brazil', p: 0.02527109271347983 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 1.6045838419191393e-5,
      Labor: 2.679910157647033e-6,
      Overhead: 5.124368012267833e-6,
      'Value Add': 4.919808885618988e-6,
    },
  },
  n34: {
    name: 'Iron(III) chloride (FeCl3, chlorination catalyst)',
    cost: 5.122297857072535e-5,
    mass: 8.256400443634501e-5,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5141008874290294 },
      { n: 'Rest of World', p: 0.4348814702089724 },
      { n: 'Poland', p: 0.05101764236199828 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 2.8857570915369906e-5,
      Labor: 4.345326277909931e-6,
      Overhead: 9.172071688091337e-6,
      'Value Add': 8.848009689354178e-6,
    },
  },
  n19: {
    name: 'Calcium hydroxide',
    cost: 0.0012263203323010458,
    mass: 0.006644465224515002,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.4354876126718029 },
      { n: 'Malaysia', p: 0.07007639411925853 },
      { n: 'Rest of World', p: 0.38982559546761253 },
      { n: 'Japan', p: 0.104610397741326 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.00014553833112666853,
      Labor: 3.9086397950081794e-5,
      Overhead: 0.0009716874995428082,
      'Value Add': 7.000810368148718e-5,
    },
    steps: [
      {
        p: 'Calcination',
        o: 'Calcine limestone (CaCO3) in a kiln to decompose it into quicklime (CaO) and CO2 gas',
        c: 0.0006617278918512245,
        e: 0.005394003128041907,
      },
      {
        p: 'Batch liquid-phase reaction',
        o: 'Slake quicklime (CaO) by reacting with water to produce Ca(OH)2 slurry (exothermic hydration reaction)',
        c: 0.00024860838139333617,
        e: 0.0021441307370878397,
      },
      {
        p: 'Atmospheric drying',
        o: 'Dry the Ca(OH)2 slurry to remove excess moisture and yield dry calcium hydroxide powder',
        c: 4.410337083372971e-5,
        e: 0.0007628703254124248,
      },
      {
        p: 'Screening/classification',
        o: 'Screen/classify dried calcium hydroxide powder to target particle size',
        c: 1.427176472817055e-6,
        e: 7.23124506523332e-6,
      },
    ],
  },
  n42: {
    name: 'Limestone (calcium carbonate)',
    cost: 0.00014181473509137385,
    mass: 0.009541452062403541,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.4354876126718029 },
      { n: 'Malaysia', p: 0.07007639411925853 },
      { n: 'Rest of World', p: 0.3898255954676126 },
      { n: 'Japan', p: 0.104610397741326 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 7.590121684224326e-5,
      Labor: 1.906748507446749e-5,
      Overhead: 1.499939932167398e-5,
      'Value Add': 3.184663385298912e-5,
    },
  },
  n43: {
    name: 'Water',
    cost: 3.723596035294691e-6,
    mass: 0.0016478273756797203,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.4354876126718029 },
      { n: 'Malaysia', p: 0.07007639411925853 },
      { n: 'Rest of World', p: 0.3898255954676126 },
      { n: 'Japan', p: 0.104610397741326 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 2.105157023704923e-6,
      Labor: 3.1815934923964654e-7,
      Overhead: 2.0203970520953368e-7,
      'Value Add': 1.098239957140588e-6,
    },
  },
  n21: {
    name: 'Hydrogen fluoride',
    cost: 0.0008693156761886112,
    mass: 0.0004115152178325001,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.558811729330456 },
      { n: 'Rest of World', p: 0.26801728009041925 },
      { n: 'Japan', p: 0.11601617606950396 },
      { n: 'United States', p: 0.05715481450962087 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.00048361133700226854,
      Labor: 8.279246316641678e-5,
      Overhead: 0.00015463197372923967,
      'Value Add': 0.00014827990229068625,
    },
  },
  n22: {
    name: 'Sodium dodecyl sulfate',
    cost: 0.0002755741278084963,
    mass: 0.00010036956532500003,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.4858280643717299 },
      { n: 'Rest of World', p: 0.4319241163949414 },
      { n: 'Japan', p: 0.04689418170285366 },
      { n: 'United States', p: 0.03535363753047516 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.00016424362553160314,
      Labor: 2.1765044881390968e-5,
      Overhead: 3.8106598566000114e-5,
      'Value Add': 5.145885882950207e-5,
    },
    steps: [
      {
        p: 'Gas-phase synthesis',
        o: 'Sulfation of lauryl alcohol with SO3 in a falling-film reactor to form dodecyl sulfuric acid',
        c: 6.0567998064126055e-6,
        e: 3.105939006791313e-5,
      },
      {
        p: 'Aqueous neutralization',
        o: 'Neutralize dodecyl sulfuric acid intermediate with sodium hydroxide solution to form SDS paste',
        c: 1.5211158475857876e-7,
        e: 3.6183580126047863e-6,
      },
      {
        p: 'Spray Drying',
        o: 'Spray dry aqueous SDS paste into powder or flake form',
        c: 1.5792010437642423e-5,
        e: 3.5862709444474e-5,
      },
    ],
  },
  n35: {
    name: '1-Dodecanol (lauryl alcohol)',
    cost: 0.00014549857870799196,
    mass: 6.684613050645002e-5,
    profile: 'material',
    sources: [
      { n: 'Indonesia', p: 0.2248315409699353 },
      { n: 'Malaysia', p: 0.2100506969363669 },
      { n: 'Rest of World', p: 0.51079542482046 },
      { n: 'Philippines', p: 0.05432233727323785 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.00010111459264762802,
      Labor: 8.444113753733159e-6,
      Overhead: 1.574689492024868e-5,
      'Value Add': 2.019297738638212e-5,
    },
  },
  n37: {
    name: 'Sulfur trioxide (SO3)',
    cost: 1.6146007677700534e-5,
    mass: 2.8705695682950006e-5,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.4858280643717299 },
      { n: 'Rest of World', p: 0.4319241163949413 },
      { n: 'Japan', p: 0.04689418170285366 },
      { n: 'United States', p: 0.03535363753047516 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 9.002166411904216e-6,
      Labor: 1.5083298843515716e-6,
      Overhead: 2.8753602976512065e-6,
      'Value Add': 2.760151083793541e-6,
    },
  },
  n36: {
    name: 'Sodium hydroxide',
    cost: 2.5990391459106214e-6,
    mass: 1.4352847841475003e-5,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.4856340930457475 },
      { n: 'Rest of World', p: 0.4372396799105183 },
      { n: 'Japan', p: 0.046589801719023646 },
      { n: 'United States', p: 0.03053642532471056 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 1.4496846737730548e-6,
      Labor: 2.419174152087581e-7,
      Overhead: 4.6294974794257253e-7,
      'Value Add': 4.4448730898623583e-7,
    },
  },
  n20: {
    name: 'Diisopropyl peroxydicarbonate',
    cost: 7.42155041266445e-5,
    mass: 2.0073913065000004e-5,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.558811729330456 },
      { n: 'Rest of World', p: 0.26801728009041925 },
      { n: 'Japan', p: 0.11601617606950396 },
      { n: 'United States', p: 0.05715481450962087 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 4.5408881009167844e-5,
      Labor: 6.1483258369039334e-6,
      Overhead: 8.431326888916283e-6,
      'Value Add': 1.422697039165644e-5,
    },
    steps: [
      {
        p: 'Batch liquid-phase reaction',
        o: 'React isopropyl chloroformate with H2O2 and NaOH in toluene solvent at low temperature to form IPP',
        c: 1.6985510513216467e-6,
        e: 6.502569238560556e-6,
      },
      {
        p: 'Liquid-liquid extraction',
        o: 'Separate IPP-containing toluene organic phase from aqueous salt/byproduct phase',
        c: 1.2129943376753087e-7,
        e: 2.3030157233925903e-5,
      },
      {
        p: 'Aqueous rinsing',
        o: 'Wash organic phase with cold water to remove residual NaCl and aqueous impurities',
        c: 5.165937625278235e-8,
        e: 9.625863789675861e-8,
      },
      {
        p: 'Vacuum drying',
        o: 'Remove residual water and toluene solvent from IPP product under mild vacuum at low temperature',
        c: 2.1609068105579316e-6,
        e: 7.340057489895839e-7,
      },
    ],
  },
  n39: {
    name: 'Isopropyl chloroformate',
    cost: 3.211504146340005e-5,
    mass: 2.9829834814590006e-5,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5974273522478267 },
      { n: 'Rest of World', p: 0.307424467980437 },
      { n: 'Japan', p: 0.029103027861183666 },
      { n: 'Taiwan', p: 0.026354134977632525 },
      { n: 'United States', p: 0.03969101693292017 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 2.2395609464914773e-5,
      Labor: 1.7630745787719052e-6,
      Overhead: 3.483867113044683e-6,
      'Value Add': 4.4724903066686895e-6,
    },
  },
  n40: {
    name: 'Sodium hydroxide',
    cost: 1.774596091381276e-6,
    mass: 1.0418360880735003e-5,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5585886186045392 },
      { n: 'Rest of World', p: 0.27678122137930605 },
      { n: 'Japan', p: 0.11526314018074876 },
      { n: 'United States', p: 0.049367019835406006 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 9.87910849446185e-7,
      Labor: 1.6800683421722886e-7,
      Overhead: 3.1577540892587557e-7,
      'Value Add': 3.029029987919865e-7,
    },
  },
  n38: {
    name: 'Hydrogen peroxide (50% aqueous solution)',
    cost: 4.5998398981385704e-6,
    mass: 9.515034792810002e-6,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.2900833753211917 },
      { n: 'Thailand', p: 0.11613279168541371 },
      { n: 'Rest of World', p: 0.35089161660876 },
      { n: 'Japan', p: 0.1497908743340034 },
      { n: 'South Korea', p: 0.03745703412519288 },
      { n: 'Canada', p: 0.029071804756413622 },
      { n: 'United States', p: 0.02657250316902468 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 2.515231857092125e-6,
      Labor: 5.025360415284113e-7,
      Overhead: 8.108776426613999e-7,
      'Value Add': 7.711943568566346e-7,
    },
  },
  n41: {
    name: 'Toluene',
    cost: 6.919403556247947e-6,
    mass: 7.025869572750001e-6,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5061364252136529 },
      { n: 'Rest of World', p: 0.3813907850342461 },
      { n: 'Japan', p: 0.11247278975210102 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 4.700548016229188e-6,
      Labor: 1.2520496321508545e-7,
      Overhead: 6.138761982140924e-7,
      'Value Add': 1.4797743785895805e-6,
    },
  },
  n2: {
    name: 'Steel can (low-alloyed steel)',
    cost: 1.0764410379676854,
    mass: 0.280869565,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.8357213491197337 },
      { n: 'Rest of World', p: 0.16427865088026627 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.22652325068301066,
      Labor: 0.2074902314259738,
      Overhead: 0.13524998328699286,
      'Value Add': 0.507177572571708,
    },
    steps: [
      {
        p: 'Shearing',
        o: 'Cut steel coil or sheet into blanks for deep drawing',
        c: 0.004395486134487798,
        e: 0.0038032484341058745,
      },
      {
        p: 'Deep Drawing',
        o: 'Press steel blanks into cylindrical or prismatic can shape',
        c: 0.06107616662145859,
        e: 0.002988460341461836,
      },
      {
        p: 'Mechanical trimming',
        o: 'Trim excess flange and flash from drawn can edges',
        c: 0.100867419880529,
        e: 0.009661518885107176,
      },
    ],
  },
  n53: {
    name: 'low-alloyed steel',
    cost: 0.22652325068301066,
    mass: 0.28648695630000004,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.3158750184896089 },
      { n: 'Japan', p: 0.2816493263261537 },
      { n: 'Germany', p: 0.15626187302260497 },
      { n: 'Rest of World', p: 0.24621378216163253 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.14283432436366178,
      Labor: 0.014470767148431976,
      Overhead: 0.017188223211876175,
      'Value Add': 0.05202993595904072,
    },
  },
  n3: {
    name: 'Anode coated foil',
    cost: 3.2030372546455403,
    mass: 0.251304348,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.8357213491197337 },
      { n: 'Rest of World', p: 0.16427865088026627 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 2.1978731038427144,
      Labor: 0.3288068362150508,
      Overhead: 0.21863793482102167,
      'Value Add': 0.4577193797667537,
    },
  },
  n4: {
    name: 'Lithium-ion battery electrolyte solution (organic carbonate-based solvent mixture)',
    cost: 0.9588475408243861,
    mass: 0.11152173925000002,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.9614786754211425 },
      { n: 'Rest of World', p: 0.038521324578857485 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.3336100786689632,
      Labor: 0.13018854291890705,
      Overhead: 0.1252483834994502,
      'Value Add': 0.3698005357370656,
    },
    steps: [
      {
        p: 'Inert-atmosphere mixing',
        o: 'Blend diethyl carbonate, dimethyl carbonate, and ethylene carbonate into a homogeneous solvent mixture under dry inert atmosphere',
        c: 0.05826989747502211,
        e: 0.0008224217272140687,
      },
      {
        p: 'Aqueous dissolution',
        o: 'Dissolve lithium hexafluorophosphate (LiPF₆) into the blended carbonate solvent mixture under inert atmosphere to form the electrolyte solution',
        c: 0.019772333345409787,
        e: 0.010594044057400581,
      },
    ],
  },
  n55: {
    name: 'dimethyl carbonate',
    cost: 0.022382325254145623,
    mass: 0.033456521775000005,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.7889180522211209 },
      { n: 'Rest of World', p: 0.2110819477788791 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.015784955466496872,
      Labor: 0.0009983650403308413,
      Overhead: 0.0024466877529666707,
      'Value Add': 0.003152316994351237,
    },
  },
  n56: {
    name: 'ethylene carbonate',
    cost: 0.025923277618018763,
    mass: 0.033456521775000005,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.34093453859418865 },
      { n: 'Rest of World', p: 0.34494340472485024 },
      { n: 'Saudi Arabia', p: 0.18348371498303648 },
      { n: 'South Korea', p: 0.13063834169792465 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.01776741263851803,
      Labor: 0.0018282257013452548,
      Overhead: 0.002779417876775673,
      'Value Add': 0.0035482214013798034,
    },
  },
  n54: {
    name: 'diethyl carbonate',
    cost: 0.03474782782443764,
    mass: 0.031226086990000006,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.7443598132769912 },
      { n: 'Rest of World', p: 0.22692634237067175 },
      { n: 'Japan', p: 0.02871384435233708 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.024432828233445215,
      Labor: 0.0016449512941345897,
      Overhead: 0.0037907174793698237,
      'Value Add': 0.004879330817488009,
    },
  },
  n57: {
    name: 'lithium hexafluorophosphate (LiPF6)',
    cost: 0.25055664797236116,
    mass: 0.013382608710000002,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.7938048484201263 },
      { n: 'Rest of World', p: 0.2061951515798737 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.14341843618407835,
      Labor: 0.017920296669738753,
      Overhead: 0.045244438740014895,
      'Value Add': 0.04397347637852916,
    },
  },
  n5: {
    name: 'Separator film (polyolefin plastic)',
    cost: 4.5833649399106875,
    mass: 0.088695652,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.9556370173911576 },
      { n: 'Rest of World', p: 0.044362982608842416 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.10354177640170939,
      Labor: 1.0683230988081747,
      Overhead: 0.7130567487424844,
      'Value Add': 2.6984433159583197,
    },
    steps: [
      {
        p: 'Polymer extrusion',
        o: 'Melt-extrude polyethylene into a flat precursor film',
        c: 0.1771508218680159,
        e: 0.03492250780706521,
      },
      {
        p: 'Biaxial film stretching',
        o: 'Stretch extruded PE film biaxially to create microporous structure',
        c: 0.4257807600255648,
        e: 0.005834058372535955,
      },
      {
        p: 'Rotary slitting',
        o: 'Slit wide microporous film web into finished separator roll widths',
        c: 0.04323180693559923,
        e: 0.0009854268404590701,
      },
    ],
  },
  n58: {
    name: 'polyethylene',
    cost: 0.10354177640170939,
    mass: 0.09046956504,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5905807318965278 },
      { n: 'Iran', p: 0.20695523256437007 },
      { n: 'Saudi Arabia', p: 0.10506150860950388 },
      { n: 'United Arab Emirates', p: 0.09740252692959801 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0769659286534656,
      Labor: 0.006292682139946073,
      Overhead: 0.008721681917298685,
      'Value Add': 0.011561483690999028,
    },
  },
  n6: {
    name: 'Top cap and vent',
    cost: 1.096183536908467,
    mass: 0.073913043,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.8357213491197337 },
      { n: 'Rest of World', p: 0.16427865088026627 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.3516383736628378,
      Labor: 0.26181976705468435,
      Overhead: 0.1182561449842374,
      'Value Add': 0.3644692512067075,
    },
    steps: [
      {
        p: 'Sheet metal stamping',
        o: 'Stamp and form stainless steel cap plate blanks to shape',
        c: 0.002797998477507047,
        e: 0.007144827509409794,
      },
      {
        p: 'Sheet metal stamping',
        o: 'Stamp and coin aluminum vent disk with scored pressure-relief groove',
        c: 0.0022067165893952163,
        e: 0.01037077715002816,
      },
      {
        p: 'Sheet metal stamping',
        o: 'Stamp and form aluminum current interrupt disk to shape',
        c: 0.0007061466335552955,
        e: 0.0033186361162271523,
      },
      {
        p: 'Sheet metal stamping',
        o: 'Stamp and form nickel-plated steel terminal button to shape',
        c: 0.0008609213540888693,
        e: 0.0021984052613255906,
      },
      {
        p: 'Sheet metal stamping',
        o: 'Stamp and form nickel-plated steel collector tab to shape',
        c: 0.00021523033852221732,
        e: 0.0005496013153313976,
      },
      {
        p: 'Injection molding',
        o: 'Injection mold polypropylene gasket rings to net shape',
        c: 0.0028801504088423746,
        e: 0.010259693545975173,
      },
      {
        p: 'Injection molding',
        o: 'Injection mold nylon sealing washers to net shape',
        c: 0.0011475178721527866,
        e: 0.0031631578867381276,
      },
      {
        p: 'Mechanical assembly',
        o: 'Stack and locate all cap, vent, disk, gasket, washer, tab, and terminal components into assembly fixture',
        c: 0.03053573775093403,
        e: 1.5210424381595903e-5,
      },
      {
        p: 'Mechanical Seaming',
        o: 'Crimp and seam cap plate edges to lock all sub-components into hermetic assembly',
        c: 0.0019508505788538204,
        e: 0.0007474110864191288,
      },
      {
        p: 'Integrity Testing',
        o: 'Leak and continuity test completed cap-and-vent assemblies',
        c: 0.08551316926364569,
        e: 0.00038648149359222887,
      },
    ],
  },
  n23: {
    name: 'Cap plate (stainless steel)',
    cost: 0.16074019797110745,
    mass: 0.03431676996428571,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.7903397866533789 },
      { n: 'Rest of World', p: 0.2096602133466211 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.07329198270463433,
      Labor: 0.03652208836946034,
      Overhead: 0.01569880466052957,
      'Value Add': 0.03522732223648322,
    },
    steps: [
      {
        p: 'Shearing',
        o: 'Cut stainless steel sheet stock to blank size',
        c: 0.0009103481906829715,
        e: 0.00046035565215775544,
      },
      {
        p: 'Sheet metal stamping',
        o: 'Press-form blank into cap plate shape using die set',
        c: 0.004856687526882109,
        e: 0.007078291291310527,
      },
      {
        p: 'Mechanical deburring',
        o: 'Remove burrs and sharp edges from formed cap plate',
        c: 0.01800582527456024,
        e: 0.00045820138959083484,
      },
    ],
  },
  n45: {
    name: 'stainless steel',
    cost: 0.07329198270463433,
    mass: 0.03500310536357142,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.5378027592566008 },
      { n: 'Indonesia', p: 0.21144348377012012 },
      { n: 'Rest of World', p: 0.250753756973279 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.047718090785154745,
      Labor: 0.0025429110883244195,
      Overhead: 0.005648819934604386,
      'Value Add': 0.017382160896550772,
    },
  },
  n29: {
    name: 'Vent disk (aluminum wrought alloy)',
    cost: 0.09689993602989228,
    mass: 0.013198757678571428,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.7830947812639797 },
      { n: 'Rest of World', p: 0.21690521873602026 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.04328836527979409,
      Labor: 0.020040720077824016,
      Overhead: 0.008480653176175752,
      'Value Add': 0.025090197496098417,
    },
    steps: [
      {
        p: 'Shearing',
        o: 'Cut aluminum wrought alloy stock to blank size for disk',
        c: 7.230526888609658e-5,
        e: 0.00021766375057206828,
      },
      {
        p: 'CNC machining',
        o: 'Machine disk profile and vent features to final dimensions',
        c: 0.010360630519049629,
        e: 0.0023283126984270106,
      },
      {
        p: 'Mechanical deburring',
        o: 'Remove burrs and sharp edges from machined vent disk',
        c: 0.0009197904094149884,
        e: 0.0001759668612317104,
      },
    ],
  },
  n46: {
    name: 'aluminum wrought alloy',
    cost: 0.04328836527979409,
    mass: 0.013462732832142858,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.7061104425301847 },
      { n: 'Rest of World', p: 0.29388955746981527 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.030171547272934852,
      Labor: 0.0029289859599552198,
      Overhead: 0.0022716906639761365,
      'Value Add': 0.007916141382927882,
    },
  },
  n28: {
    name: 'Terminal button (nickel-plated low-alloyed steel)',
    cost: 0.025228830896025237,
    mass: 0.010559006142857144,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.8101853710204057 },
      { n: 'Rest of World', p: 0.18981462897959436 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.010122221484782234,
      Labor: 0.00478752537466463,
      Overhead: 0.004445747156675986,
      'Value Add': 0.005873336879902386,
    },
    steps: [
      {
        p: 'Sheet metal stamping',
        o: 'Stamp and form low-alloyed steel blanks into terminal button shape',
        c: 0.0007394509088889752,
        e: 0.002165015538891186,
      },
      {
        p: 'Mechanical deburring',
        o: 'Remove burrs and sharp edges from stamped steel buttons',
        c: 0.0010863945522197483,
        e: 0.00014014867255088945,
      },
      {
        p: 'Surface preparation',
        o: 'Degrease and clean steel buttons prior to plating',
        c: 0.0008753631300103112,
        e: 0.0034237810518957888,
      },
      {
        p: 'Electrodeposition',
        o: 'Electroplate nickel coating onto steel terminal buttons',
        c: 0.002323729748235575,
        e: 0.009284750522405119,
      },
    ],
  },
  n47: {
    name: 'low-alloyed steel',
    cost: 0.008313133849037776,
    mass: 0.010453416081428572,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.3062232636759122 },
      { n: 'Japan', p: 0.27304335851603284 },
      { n: 'Germany', p: 0.1514871957076504 },
      { n: 'Rest of World', p: 0.26924618210040463 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.005243363848026127,
      Labor: 0.0005289062392691819,
      Overhead: 0.0006308754837977424,
      'Value Add': 0.0019099882779447252,
    },
  },
  n48: {
    name: 'nickel',
    cost: 0.0018090876357444573,
    mass: 0.00010559006142857144,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.4990009825852886 },
      { n: 'Australia', p: 0.2215511562584958 },
      { n: 'Russia', p: 0.20854944535788303 },
      { n: 'China', p: 0.07089841579833264 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0010973626395810532,
      Labor: 0.0002509014873286128,
      Overhead: 0.00010034465087044696,
      'Value Add': 0.0003604788579643443,
    },
  },
  n26: {
    name: 'Gasket ring (polypropylene)',
    cost: 0.01820813948727572,
    mass: 0.0063354036857142864,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.802722303549931 },
      { n: 'Rest of World', p: 0.19727769645006893 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.007471887447789768,
      Labor: 0.002773046052341405,
      Overhead: 0.003066148204678985,
      'Value Add': 0.004897057782465564,
    },
    steps: [
      {
        p: 'Injection molding',
        o: 'Melt and inject polypropylene into ring-shaped gasket mold cavity',
        c: 0.002474260048050772,
        e: 0.01019023188190636,
      },
      {
        p: 'Mechanical trimming',
        o: 'Remove sprue, runners, and flash from molded gasket rings',
        c: 0.0008534285578910804,
        e: 0.0002857564830999478,
      },
    ],
  },
  n52: {
    name: 'polypropylene',
    cost: 0.007471887447789768,
    mass: 0.006652173870000001,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5645810473278912 },
      { n: 'China', p: 0.22580206001685055 },
      { n: 'South Korea', p: 0.12864785941863893 },
      { n: 'United Arab Emirates', p: 0.08096903323661925 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.005542929482232178,
      Labor: 0.0004676155853120462,
      Overhead: 0.0006287078635138408,
      'Value Add': 0.0008326345167317026,
    },
  },
  n25: {
    name: 'Current interrupt disk (aluminum wrought alloy)',
    cost: 0.03185585143081514,
    mass: 0.004223602457142857,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.6603615306738312 },
      { n: 'Rest of World', p: 0.2961132485780601 },
      { n: 'South Korea', p: 0.04352522074810865 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.013627510331151553,
      Labor: 0.00749654696665164,
      Overhead: 0.002824541843627255,
      'Value Add': 0.007907252289384686,
    },
    steps: [
      {
        p: 'Hole forming',
        o: 'Punch/blank aluminum sheet into circular disk form',
        c: 0.0016151124446742945,
        e: 3.345266059953462e-5,
      },
      {
        p: 'Mechanical deburring',
        o: 'Remove burrs and sharp edges from stamped disk perimeter',
        c: 0.0025258154541263128,
        e: 5.4524760558269354e-5,
      },
    ],
  },
  n49: {
    name: 'aluminum wrought alloy',
    cost: 0.013627510331151553,
    mass: 0.004308074506285713,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.6058730692631652 },
      { n: 'Rest of World', p: 0.3636684150645513 },
      { n: 'South Korea', p: 0.03045851567228342 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.009432524567577647,
      Labor: 0.0010084396826613167,
      Overhead: 0.0007117244418557557,
      'Value Add': 0.0024748216390568325,
    },
  },
  n24: {
    name: 'Collector tab (nickel-plated low-alloyed steel)',
    cost: 0.006542888791073271,
    mass: 0.002639751535714286,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.6984301733745079 },
      { n: 'Rest of World', p: 0.30156982662549214 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.002582466752292833,
      Labor: 0.0013370352052069294,
      Overhead: 0.001124931455950487,
      'Value Add': 0.0014984553776230226,
    },
    steps: [
      {
        p: 'Rotary slitting',
        o: 'Slit wide steel coil to required tab width',
        c: 4.674919034726096e-5,
        e: 4.284015502237695e-5,
      },
      {
        p: 'Sheet metal stamping',
        o: 'Stamp/blank steel strip into collector tab shape',
        c: 0.0002231581009614272,
        e: 0.0005287772703202049,
      },
      {
        p: 'Surface preparation',
        o: 'Degrease and clean steel tabs prior to plating',
        c: 0.00032329488402963466,
        e: 0.0008401266517882476,
      },
      {
        p: 'Electrodeposition',
        o: 'Electroplate nickel layer onto steel tab surface',
        c: 0.0007385148266659036,
        e: 0.0022676812007344357,
      },
    ],
  },
  n50: {
    name: 'low-alloyed steel',
    cost: 0.0021304611042941846,
    mass: 0.002613354020357143,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.26398349660535675 },
      { n: 'Japan', p: 0.23538035497595727 },
      { n: 'Germany', p: 0.13059138333842796 },
      { n: 'Rest of World', p: 0.370044765080258 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0013454518377901412,
      Labor: 0.0001331269857158713,
      Overhead: 0.0001617775859393179,
      'Value Add': 0.000490104694848854,
    },
  },
  n51: {
    name: 'nickel',
    cost: 0.00045200564799864845,
    mass: 2.639751535714286e-5,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5681076910180325 },
      { n: 'Australia', p: 0.1909908744489619 },
      { n: 'Russia', p: 0.17978259110629524 },
      { n: 'China', p: 0.061118843426710354 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0002742023849541325,
      Labor: 6.265625041606587e-5,
      Overhead: 2.5072720854582555e-5,
      'Value Add': 9.007429177386752e-5,
    },
  },
  n27: {
    name: 'Sealing washer (nylon)',
    cost: 0.01216252905664872,
    mass: 0.002639751535714286,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.802722303549931 },
      { n: 'Rest of World', p: 0.19727769645006893 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0052534500236559225,
      Labor: 0.0019497160457872319,
      Overhead: 0.0015162639706715073,
      'Value Add': 0.00344309901653406,
    },
    steps: [
      {
        p: 'Injection molding',
        o: 'Inject molten nylon into washer-shaped mold cavities',
        c: 0.0010526307000035633,
        e: 0.0031417422168118635,
      },
      {
        p: 'Mechanical trimming',
        o: 'Remove sprue, runners, and flash from molded washers',
        c: 0.0004434678297050848,
        e: 0.00011906520129164492,
      },
      {
        p: 'Mechanical deburring',
        o: 'Smooth edges of washers to final sealing surface finish',
        c: 0.00020405330554891095,
        e: 3.533665302918679e-5,
      },
    ],
  },
  n44: {
    name: 'polyamide (nylon)',
    cost: 0.0052534500236559225,
    mass: 0.0026925465664285717,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.45573234729917456 },
      { n: 'Rest of World', p: 0.461522297326953 },
      { n: 'United States', p: 0.0473556413689302 },
      { n: 'Thailand', p: 0.0353897140049422 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0039571173991045094,
      Labor: 0.0002562478245015805,
      Overhead: 0.00044566400797308765,
      'Value Add': 0.0005944207920767451,
    },
  },
  n7: {
    name: 'Metal current tabs',
    cost: 0.523170527475854,
    mass: 0.023652174,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.7184453700203068 },
      { n: 'Rest of World', p: 0.17904193933524482 },
      { n: 'Japan', p: 0.10251269064444836 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.29588655839734407,
      Labor: 0.10729887554687237,
      Overhead: 0.031249752995091046,
      'Value Add': 0.08873534053654651,
    },
    steps: [
      {
        p: 'Sheet rolling',
        o: 'Roll copper strip/sheet to target thickness for battery tabs',
        c: 0.003497777259124505,
        e: 0.00283346012369941,
      },
      {
        p: 'Rotary slitting',
        o: 'Slit rolled copper strip to precise tab width',
        c: 0.003778590440392919,
        e: 0.00038999190935639933,
      },
      {
        p: 'Die cutting',
        o: 'Stamp or punch copper strip into individual tab shapes',
        c: 0.024184447694694796,
        e: 0.0005744326467104204,
      },
    ],
  },
  n30: {
    name: 'copper',
    cost: 0.29588655839734407,
    mass: 0.024125217480000002,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5302266137215714 },
      { n: 'Chile', p: 0.16736562370278904 },
      { n: 'DR Congo', p: 0.14243892858955862 },
      { n: 'Russia', p: 0.05923881363227368 },
      { n: 'Japan', p: 0.10073002035380735 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.20332614380773556,
      Labor: 0.010791661544223428,
      Overhead: 0.015373929114666523,
      'Value Add': 0.06639482393071855,
    },
  },
  n8: {
    name: 'Insulators (polypropylene)',
    cost: 0.11113680344022048,
    mass: 0.020695652,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.8357213491197337 },
      { n: 'Rest of World', p: 0.16427865088026627 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.02366152052793378,
      Labor: 0.0213268580323183,
      Overhead: 0.017871158042210428,
      'Value Add': 0.04827726683775796,
    },
    steps: [
      {
        p: 'Injection molding',
        o: 'Melt and inject PP into a closed mold to form the battery cell insulator shape',
        c: 0.017743777924876317,
        e: 0.03351501834993025,
      },
    ],
  },
  n59: {
    name: 'polypropylene (PP)',
    cost: 0.02366152052793378,
    mass: 0.02110956504,
    profile: 'material',
    sources: [
      { n: 'Rest of World', p: 0.5466814451894677 },
      { n: 'China', p: 0.23508453844718594 },
      { n: 'South Korea', p: 0.13393643375703612 },
      { n: 'United Arab Emirates', p: 0.0842975826063103 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.017551724369382554,
      Labor: 0.0014823771876219553,
      Overhead: 0.0019908760408857765,
      'Value Add': 0.0026365429300434944,
    },
  },
  n9: {
    name: 'Label sleeve (polyethylene terephthalate (PET))',
    cost: 0.10692043826953039,
    mass: 0.014782609,
    profile: 'assembly',
    sources: [
      { n: 'China', p: 0.9616642694747015 },
      { n: 'Rest of World', p: 0.038335730525298484 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.019292559602872298,
      Labor: 0.029011420812762135,
      Overhead: 0.01954161356482538,
      'Value Add': 0.03907484428907058,
    },
    steps: [
      {
        p: 'Polymer extrusion',
        o: 'Extrude PET resin into thin flat or tubular film substrate',
        c: 0.0075115597352150825,
        e: 0.0054778154710935344,
      },
      {
        p: 'Roll-to-roll printing',
        o: 'Print graphics onto PET film using solvent-based inks',
        c: 0.006657799020409928,
        e: 0.006753081336332557,
      },
      {
        p: 'Roll-to-roll coating',
        o: 'Apply acrylic varnish topcoat over printed film surface',
        c: 0.0033710625137490457,
        e: 0.009815363854388698,
      },
      {
        p: 'Rotary slitting',
        o: 'Slit wide printed and coated web into finished label rolls',
        c: 0.00183934700639588,
        e: 0.000164436046450291,
      },
    ],
  },
  n15: {
    name: 'polyethylene terephthalate (PET)',
    cost: 0.016761922533869475,
    mass: 0.01389565246,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.9467285151857159 },
      { n: 'Rest of World', p: 0.05327148481428409 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.012844535074954816,
      Labor: 0.0005527527162142686,
      Overhead: 0.001435185109783262,
      'Value Add': 0.0019294496329171303,
    },
  },
  n14: {
    name: 'acrylic varnish (other adhesive / coating)',
    cost: 0.0010671587780028235,
    mass: 0.00044347827,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.32953825430874883 },
      { n: 'Germany', p: 0.29316616755344266 },
      { n: 'Rest of World', p: 0.2646306333502656 },
      { n: 'United States', p: 0.11266494478754287 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0006938937305021924,
      Labor: 0.00011167143585719504,
      Overhead: 3.912368628365906e-5,
      'Value Add': 0.0002224699253597771,
    },
  },
  n16: {
    name: 'solvent-based printing ink (other adhesive / coating)',
    cost: 0.0014634782909999997,
    mass: 0.00044347827,
    profile: 'material',
    sources: [
      { n: 'China', p: 0.7809443162740287 },
      { n: 'Rest of World', p: 0.21905568372597126 },
    ],
    rootCost: 32.942205761980844,
    breakdown: {
      Materials: 0.0011224094627073306,
      Labor: 0.00012146525470997638,
      Overhead: 6.735636571801826e-5,
      'Value Add': 0.00015224720786467458,
    },
  },
} as Record<
  string,
  {
    name: string
    cost: number
    mass: number
    profile: string
    sources: Array<{ n: string; p: number }>
    rootCost: number
    breakdown?: Record<string, number>
  }
>
